(function () {
  'use strict';


  const ADDON_MIN_QUANTITY = 1;
  const ADDON_MAX_QUANTITY = 4;


  window.__addonPendingBundles =
    window.__addonPendingBundles || {};


  /* =========================================================
     SHOPIFY ROUTE
     ========================================================= */

  function routesRoot() {

    return (
      (window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      '/'
    );

  }


  /* =========================================================
     BUNDLE ID
     ========================================================= */

  function newBundleId() {

    return (
      `${Date.now().toString(36)}-` +
      `${Math.random().toString(36).slice(2, 8)}`
    );

  }


  /* =========================================================
     PRODUCT FORM
     ========================================================= */

  function findProductForm() {

    return (
      document.querySelector(
        '.product-info__buy-buttons form'
      ) ||
      document.querySelector(
        'form[action*="/cart/add"]'
      )
    );

  }


  /* =========================================================
     HAUPTPRODUKT-MENGE
     ========================================================= */

  function getMainQuantity() {

    const input =
      document.querySelector(
        '.product-info__quantity-selector .quantity-selector__input'
      ) ||
      document.querySelector(
        'input[name="quantity"]'
      );


    const quantity =
      parseInt(
        input?.value || '1',
        10
      );


    return Number.isNaN(quantity)
      ? 1
      : Math.max(
          1,
          quantity
        );

  }


  /* =========================================================
     FARBNAMEN → SWATCH-FARBE
     ========================================================= */

  function resolveSwatchColor(value) {

    if (!value) {

      return '#d9d9d9';

    }


    const normalized =
      value
        .toLowerCase()
        .trim();


    const colors = {

      schwarz: '#111111',
      black: '#111111',

      weiß: '#ffffff',
      weiss: '#ffffff',
      white: '#ffffff',

      grau: '#969696',
      gray: '#969696',
      grey: '#969696',

      hellgrau: '#c4c4c4',
      'light gray': '#c4c4c4',
      'light grey': '#c4c4c4',

      dunkelgrau: '#555555',
      'dark gray': '#555555',
      'dark grey': '#555555',

      anthrazit: '#464646',
      anthracite: '#464646',

      beige: '#dfc99e',

      creme: '#eee2cb',
      cream: '#eee2cb',

      blau: '#3975b9',
      blue: '#3975b9',

      hellblau: '#a9d8ef',
      'light blue': '#a9d8ef',

      dunkelblau: '#1e3557',

      denim: '#637A8C',

      navy: '#1e3557',
      'navy blue': '#1e3557',

      rot: '#c83b3b',
      red: '#c83b3b',

      grün: '#55765a',
      gruen: '#55765a',
      green: '#55765a',

      oliv: '#737459',
      olive: '#737459',
      olivgrün: '#737459',

      braun: '#795548',
      brown: '#795548',

      rosa: '#e8b5c1',
      pink: '#e8b5c1',

      mint: '#a8d9c7',
      mintgrün: '#a8d9c7',

      lila: '#9674ad',
      purple: '#9674ad',

      orange: '#dc8a45',

      gelb: '#e7ca57',
      yellow: '#e7ca57'

    };


    if (
      colors[normalized]
    ) {

      return colors[normalized];

    }


    return normalized;

  }


  /* =========================================================
     SWATCH-FARBEN ANWENDEN
     ========================================================= */

  function applySwatchColors(root = document) {

    root
      .querySelectorAll(
        '[data-addon-swatch]'
      )
      .forEach(
        (swatch) => {

          const colorElement =
            swatch.querySelector(
              '[data-addon-swatch-color]'
            );


          if (!colorElement) {

            return;

          }


          colorElement.style.backgroundColor =
            resolveSwatchColor(
              swatch.dataset.color
            );

        }
      );

  }


  /* =========================================================
     WARTEN
     ========================================================= */

  function sleep(ms) {

    return new Promise(
      (resolve) => setTimeout(resolve, ms)
    );

  }


  /* =========================================================
     IMPACT CART REFRESH

     WICHTIG:
     Diese Funktion aktualisiert NUR den Warenkorb.
     Der große globale Cart Drawer wird hier niemals geöffnet.
     ========================================================= */

  function refreshCart() {

    document.documentElement.dispatchEvent(
      new CustomEvent(
        'cart:refresh',
        {
          bubbles: true
        }
      )
    );

  }


  /* =========================================================
     VARIANT-ADDED POPUP ANZEIGEN
     ========================================================= */

  function showVariantAddedPopup(sectionHtml) {

    if (!sectionHtml) {

      return;

    }


    const popup =
      document.querySelector(
        'cart-notification-drawer'
      );


    if (!popup) {

      return;

    }


    const tempContent =
      document.createElement(
        'div'
      );


    tempContent.innerHTML =
      sectionHtml;


    const section =
      tempContent.querySelector(
        '.shopify-section'
      );


    if (!section) {

      return;

    }


    popup.replaceChildren(
      ...section.children
    );


    if (
      typeof popup._applyLeoMiloMobileLayout ===
      'function'
    ) {

      popup._applyLeoMiloMobileLayout();

    }


    if (
      typeof popup.show ===
      'function'
    ) {

      popup.show();

    }

  }


  /* =========================================================
     LEGACY: HAUPTPRODUKT DES BUNDLES IM WARENKORB SUCHEN
     ========================================================= */

  async function findMainBundleItem(bundleId) {

    for (
      let attempt = 0;
      attempt < 30;
      attempt++
    ) {

      try {

        const response =
          await fetch(
            `${routesRoot()}cart.js`,
            {

              method:
                'GET',

              headers: {
                'Accept':
                  'application/json'
              },

              cache:
                'no-store'

            }
          );


        if (
          response.ok
        ) {

          const cart =
            await response.json();


          const mainItem =
            cart.items.find(
              (item) => {

                return (
                  item.properties &&
                  item.properties
                    ._addon_bundle_id ===
                    bundleId &&
                  item.properties
                    ._addon_bundle_role ===
                    'main'
                );

              }
            );


          if (
            mainItem
          ) {

            return mainItem;

          }

        }

      } catch (_) {}


      await sleep(
        200
      );

    }


    return null;

  }


  /* =========================================================
     LEGACY: BUNDLE-ADDON NACH HAUPTPRODUKT HINZUFÜGEN
     ========================================================= */

  async function processPendingAddon(chooser) {

    if (
      !chooser ||
      !chooser.__pending ||
      chooser.__addonProcessing
    ) {

      return;

    }


    chooser.__addonProcessing =
      true;


    const pending =
      chooser.__pending;


    try {

      const mainItem =
        await findMainBundleItem(
          pending.bundleId
        );


      if (
        !mainItem
      ) {

        return;

      }


      const currentCartResponse =
        await fetch(
          `${routesRoot()}cart.js`,
          {

            headers: {
              'Accept':
                'application/json'
            },

            cache:
              'no-store'

          }
        );


      if (
        !currentCartResponse.ok
      ) {

        throw new Error(
          `cart.js ${currentCartResponse.status}`
        );

      }


      const currentCart =
        await currentCartResponse.json();


      const addonAlreadyExists =
        currentCart.items.some(
          (item) => {

            return (
              item.properties &&
              item.properties
                ._addon_bundle_id ===
                pending.bundleId &&
              item.properties
                ._addon_bundle_role ===
                'addon'
            );

          }
        );


      if (
        !addonAlreadyExists
      ) {

        const response =
          await fetch(
            `${routesRoot()}cart/add.js`,
            {

              method:
                'POST',

              headers: {

                'Content-Type':
                  'application/json',

                'Accept':
                  'application/json'

              },

              body:
                JSON.stringify({

                  items: [

                    {

                      id:
                        pending.variantId,

                      quantity:
                        pending.quantity ||
                        1,

                      properties: {

                        _addon_bundle_id:
                          pending.bundleId,

                        _addon_bundle_role:
                          'addon'

                      }

                    }

                  ]

                })

            }
          );


        if (
          !response.ok
        ) {

          const errorText =
            await response.text();


          throw new Error(
            `Addon cart/add failed: ${response.status} ${errorText}`
          );

        }

      }


      chooser.__pending =
        null;


      await sleep(
        200
      );


      refreshCart();


    } catch (error) {

      console.error(
        '[Addon Chooser] Add-on konnte nicht hinzugefügt werden:',
        error
      );


      try {

        const cart =
          await (
            await fetch(
              `${routesRoot()}cart.js`,
              {
                cache:
                  'no-store'
              }
            )
          ).json();


        const orphan =
          cart.items.find(
            (item) => {

              return (
                item.properties &&
                item.properties
                  ._addon_bundle_id ===
                  pending.bundleId
              );

            }
          );


        if (
          orphan
        ) {

          await fetch(
            `${routesRoot()}cart/change.js`,
            {

              method:
                'POST',

              headers: {

                'Content-Type':
                  'application/json'

              },

              body:
                JSON.stringify({

                  id:
                    orphan.key,

                  quantity:
                    0

                })

            }
          );

        }

      } catch (_) {}


      chooser.showError(

        chooser.dataset
          .textAddError ||

        'Das Zusatzprodukt konnte nicht hinzugefügt werden. Bitte versuche es erneut.'

      );


    } finally {

      delete window
        .__addonPendingBundles[
          pending.bundleId
        ];


      chooser.__addonProcessing =
        false;


      setTimeout(
        refreshCart,
        100
      );

    }

  }


  /* =========================================================
     ADDON CHOOSER
     ========================================================= */

  class AddonChooserStandalone extends HTMLElement {


    connectedCallback() {

      const sectionId =
        this.dataset.sectionId;


      if (
        sectionId
      ) {

        const selector =
          `addon-chooser-standalone[data-section-id="${CSS.escape(sectionId)}"]`;


        document
          .querySelectorAll(
            selector
          )
          .forEach(
            (chooser) => {

              if (
                chooser !== this
              ) {

                chooser.remove();

              }

            }
          );

      }


      if (
        this.__initialized
      ) {

        return;

      }


      this.__initialized =
        true;


      this.selectedCard =
        null;


      this.__pending =
        null;


      this.__addonProcessing =
        false;


      this.__standaloneAdding =
        false;


      this.bindCards();

      this.initAddonQuantities();

      this.initArrows();

      this.syncInputsToForm();

      this.moveIntoProductInfo();

      this.updatePromo();

      applySwatchColors(
        this
      );


      this.disableBundleFormProperties();


      requestAnimationFrame(
        () => {

          requestAnimationFrame(
            () => {

              this.classList.add(
                'is-addon-ready'
              );

            }
          );

        }
      );


      this.__positionInterval =
        setInterval(
          () => {

            this.syncInputsToForm();

            this.moveIntoProductInfo();

            this.disableBundleFormProperties();

          },
          1000
        );

    }


    disconnectedCallback() {

      if (
        this.__positionInterval
      ) {

        clearInterval(
          this.__positionInterval
        );

      }

    }


    /* =====================================================
       BUNDLE-FORM-PROPERTIES DEAKTIVIEREN
       ===================================================== */

    disableBundleFormProperties() {

      const labelInput =
        this.querySelector(
          '[data-addon-prop-label]'
        );


      const bundleInput =
        this.querySelector(
          '[data-addon-prop-bundle]'
        );


      const roleInput =
        this.querySelector(
          '[data-addon-prop-role]'
        );


      if (
        labelInput
      ) {

        labelInput.value =
          '';


        labelInput.disabled =
          true;

      }


      if (
        bundleInput
      ) {

        bundleInput.value =
          '';


        bundleInput.disabled =
          true;

      }


      if (
        roleInput
      ) {

        roleInput.value =
          'main';


        roleInput.disabled =
          true;

      }

    }


    /* =====================================================
       ADDON-MENGEN INITIALISIEREN
       ===================================================== */

    initAddonQuantities() {

      this
        .querySelectorAll(
          '.addon-card'
        )
        .forEach(
          (card) => {

            const index =
              parseInt(
                card.dataset.addonIndex,
                10
              );


            if (
              Number.isNaN(index) ||
              index < 0
            ) {

              return;

            }


            this.setAddonQuantity(
              card,
              ADDON_MIN_QUANTITY
            );


            const quantityWrap =
              card.querySelector(
                '[data-addon-quantity-wrap]'
              );


            const addButton =
              card.querySelector(
                '[data-addon-add-button]'
              );


            if (
              quantityWrap
            ) {

              quantityWrap.hidden =
                true;

            }


            if (
              addButton
            ) {

              addButton.hidden =
                true;

            }

          }
        );

    }


    /* =====================================================
       ADDON-MENGE AUSLESEN
       ===================================================== */

    getAddonQuantity(
      card = this.selectedCard
    ) {

      if (
        !card
      ) {

        return ADDON_MIN_QUANTITY;

      }


      const input =
        card.querySelector(
          '[data-addon-quantity-input]'
        );


      const quantity =
        parseInt(
          input?.value ||
          '1',
          10
        );


      if (
        Number.isNaN(
          quantity
        )
      ) {

        return ADDON_MIN_QUANTITY;

      }


      return Math.min(
        ADDON_MAX_QUANTITY,
        Math.max(
          ADDON_MIN_QUANTITY,
          quantity
        )
      );

    }


    /* =====================================================
       ADDON-MENGE SETZEN
       ===================================================== */

    setAddonQuantity(
      card,
      quantity
    ) {

      if (
        !card
      ) {

        return;

      }


      let safeQuantity =
        parseInt(
          quantity,
          10
        );


      if (
        Number.isNaN(
          safeQuantity
        )
      ) {

        safeQuantity =
          ADDON_MIN_QUANTITY;

      }


      safeQuantity =
        Math.min(
          ADDON_MAX_QUANTITY,
          Math.max(
            ADDON_MIN_QUANTITY,
            safeQuantity
          )
        );


      const input =
        card.querySelector(
          '[data-addon-quantity-input]'
        );


      const value =
        card.querySelector(
          '[data-addon-quantity-value]'
        );


      const minus =
        card.querySelector(
          '[data-addon-quantity-minus]'
        );


      const plus =
        card.querySelector(
          '[data-addon-quantity-plus]'
        );


      if (
        input
      ) {

        input.value =
          String(
            safeQuantity
          );

      }


      if (
        value
      ) {

        value.textContent =
          String(
            safeQuantity
          );

      }


      if (
        minus
      ) {

        minus.disabled =
          safeQuantity <=
          ADDON_MIN_QUANTITY;

      }


      if (
        plus
      ) {

        plus.disabled =
          safeQuantity >=
          ADDON_MAX_QUANTITY;

      }

    }


    /* =====================================================
       MENGENWAHL + HINZUFÜGEN-BUTTON SICHTBARKEIT
       ===================================================== */

    updateAddonControlsVisibility() {

      this
        .querySelectorAll(
          '.addon-card'
        )
        .forEach(
          (card) => {

            const index =
              parseInt(
                card.dataset.addonIndex,
                10
              );


            const isSelected =
              index >= 0 &&
              card ===
                this.selectedCard;


            const quantityWrap =
              card.querySelector(
                '[data-addon-quantity-wrap]'
              );


            const addButton =
              card.querySelector(
                '[data-addon-add-button]'
              );


            if (
              quantityWrap
            ) {

              quantityWrap.hidden =
                !isSelected;

            }


            if (
              addButton
            ) {

              addButton.hidden =
                !isSelected;

            }

          }
        );

    }


    /* =====================================================
       RÜCKWÄRTSKOMPATIBILITÄT
       ===================================================== */

    updateQuantityVisibility() {

      this.updateAddonControlsVisibility();

    }


    /* =====================================================
       ADDON DIREKT HINZUFÜGEN
       ===================================================== */

    async addStandaloneAddon(
      card
    ) {

      if (
        !card ||
        this.__standaloneAdding
      ) {

        return;

      }


      const variantId =
        parseInt(
          card.getAttribute(
            'data-variant-id'
          ),
          10
        );


      if (
        Number.isNaN(
          variantId
        )
      ) {

        this.showError(
          this.dataset.textAddError ||
          'Das Zusatzprodukt konnte nicht hinzugefügt werden. Bitte versuche es erneut.'
        );

        return;

      }


      const quantity =
        this.getAddonQuantity(
          card
        );


      const addButton =
        card.querySelector(
          '[data-addon-add-button]'
        );


      const originalText =
        addButton
          ? addButton.textContent
          : '';


      this.__standaloneAdding =
        true;


      this.clearError();


      if (
        addButton
      ) {

        addButton.disabled =
          true;


        addButton.textContent =
          'Wird hinzugefügt …';

      }


      try {

        const response =
          await fetch(
            `${routesRoot()}cart/add.js`,
            {

              method:
                'POST',

              headers: {

                'Content-Type':
                  'application/json',

                'Accept':
                  'application/json'

              },

              body:
                JSON.stringify({

                  items: [

                    {

                      id:
                        variantId,

                      quantity:
                        quantity,

                      properties: {

                        _Zusatzprodukt:
                          card.dataset.addonLabel ||
                          'Zusatzprodukt',

                        _addon_source:
                          'upsell'

                      }

                    }

                  ],

                  sections: [
                    'variant-added'
                  ],

                  sections_url:
                    window.location.pathname

                })

            }
          );


        if (
          !response.ok
        ) {

          const errorText =
            await response.text();


          throw new Error(
            `Standalone addon cart/add failed: ${response.status} ${errorText}`
          );

        }


        const responseJson =
          await response.json();


        await sleep(
          100
        );


        /*
         * Cap-Add:
         * Warenkorb aktualisieren und ausschließlich
         * den Variant-Added-Popup anzeigen.
         */
        refreshCart();


        showVariantAddedPopup(
          responseJson
            ?.sections
            ?.['variant-added'] ||
          ''
        );


        this.setAddonQuantity(
          card,
          ADDON_MIN_QUANTITY
        );


        if (
          addButton
        ) {

          addButton.textContent =
            'Hinzugefügt ✓';


          setTimeout(
            () => {

              if (
                addButton
              ) {

                addButton.textContent =
                  originalText ||
                  'Hinzufügen';

              }

            },
            1000
          );

        }


      } catch (error) {

        console.error(
          '[Addon Chooser] Direktes Hinzufügen fehlgeschlagen:',
          error
        );


        this.showError(

          this.dataset
            .textAddError ||

          'Das Zusatzprodukt konnte nicht hinzugefügt werden. Bitte versuche es erneut.'

        );


        if (
          addButton
        ) {

          addButton.textContent =
            originalText ||
            'Hinzufügen';

        }


      } finally {

        this.__standaloneAdding =
          false;


        if (
          addButton
        ) {

          addButton.disabled =
            false;

        }

      }

    }


    /* =====================================================
       INPUTS AN PRODUCT FORM BINDEN
       ===================================================== */

    syncInputsToForm() {

      const form =
        findProductForm();


      if (
        !form
      ) {

        return;

      }


      let formId =
        form.getAttribute(
          'id'
        );


      if (
        !formId
      ) {

        formId =
          `addon-product-form-${Date.now()}`;


        form.setAttribute(
          'id',
          formId
        );

      }


      this
        .querySelectorAll(
          '[data-addon-prop-bundle], [data-addon-prop-role], [data-addon-prop-label]'
        )
        .forEach(
          (input) => {

            input.setAttribute(
              'form',
              formId
            );

          }
        );


      this.disableBundleFormProperties();

    }


    /* =====================================================
       POSITION
       ===================================================== */

    moveIntoProductInfo() {

      const targetMode =
        this.dataset.moveTarget ||
        'before_buy_buttons';


      if (
        targetMode ===
        'tee_before_preview'
      ) {

        const teeFooter =
          document.querySelector(
            '#tee-artwork-form .tee-campaign-form-footer'
          );


        if (
          teeFooter
        ) {

          if (
            teeFooter.previousElementSibling !==
            this
          ) {

            teeFooter.insertAdjacentElement(
              'beforebegin',
              this
            );

          }


          return;

        }

      }


      const buyButtonBlock =
        document.querySelector(
          '.product-info__block-item[data-block-type="buy-buttons"]'
        );


      if (
        buyButtonBlock
      ) {

        if (
          buyButtonBlock.previousElementSibling !==
          this
        ) {

          buyButtonBlock.insertAdjacentElement(
            'beforebegin',
            this
          );

        }


        return;

      }


      const buyButtons =
        document.querySelector(
          '.product-info__buy-buttons'
        );


      if (
        buyButtons
      ) {

        const block =
          buyButtons.closest(
            '.product-info__block-item'
          );


        if (
          block
        ) {

          if (
            block.previousElementSibling !==
            this
          ) {

            block.insertAdjacentElement(
              'beforebegin',
              this
            );

          }

        } else if (
          buyButtons.previousElementSibling !==
          this
        ) {

          buyButtons.insertAdjacentElement(
            'beforebegin',
            this
          );

        }


        return;

      }


      const productInfo =
        document.querySelector(
          '.product-info'
        );


      if (
        productInfo &&
        this.parentElement !==
        productInfo
      ) {

        productInfo.appendChild(
          this
        );

      }

    }


    /* =====================================================
       PROMO
       ===================================================== */

    updatePromo() {

      const promoEnabled =
        this.dataset.promoEnabled ===
        'true';


      const threshold =
        parseInt(
          this.dataset.promoThreshold ||
          '2',
          10
        ) || 2;


      const quantity =
        getMainQuantity();


      const active =
        promoEnabled &&
        quantity >= threshold;


      if (
        promoEnabled
      ) {

        const promo =
          this.querySelector(
            '[data-addon-promo]'
          );


        const text =
          this.querySelector(
            '[data-addon-promo-text]'
          );


        if (
          promo &&
          text
        ) {

          if (
            active
          ) {

            text.textContent =
              this.dataset.promoActive ||
              'Cap jetzt gratis ✓';


            promo.classList.add(
              'is-active'
            );


          } else {

            const remaining =
              Math.max(
                threshold -
                  quantity,
                1
              );


            let message =
              this.dataset.promoRemaining ||
              '2 Hoodies = 1 Cap gratis';


            message =
              message.replace(
                '{count}',
                String(
                  remaining
                )
              );


            text.textContent =
              message;


            promo.classList.remove(
              'is-active'
            );

          }

        }

      }


      this
        .querySelectorAll(
          '[data-addon-price]'
        )
        .forEach(
          (price) => {

            const normalPrice =
              price.dataset.normalPrice ||
              '';


            const promoPrice =
              price.dataset.promoPrice ||
              '';


            if (
              active &&
              promoPrice.trim() !== ''
            ) {

              price.textContent =
                promoPrice;


              price.classList.add(
                'is-promo-price'
              );


            } else {

              price.textContent =
                normalPrice;


              price.classList.remove(
                'is-promo-price'
              );

            }

          }
        );

    }


    /* =====================================================
       KARTEN + MENGENBUTTONS + ADD-BUTTON
       ===================================================== */

    bindCards() {

      this.addEventListener(
        'click',
        (event) => {


          const addButton =
            event.target.closest(
              '[data-addon-add-button]'
            );


          if (
            addButton
          ) {

            event.preventDefault();
            event.stopPropagation();


            const card =
              addButton.closest(
                '.addon-card'
              );


            if (
              !card
            ) {

              return;

            }


            if (
              this.selectedCard !==
              card
            ) {

              this.selectCard(
                card,
                true
              );

            }


            this.addStandaloneAddon(
              card
            );


            return;

          }


          const quantityMinus =
            event.target.closest(
              '[data-addon-quantity-minus]'
            );


          if (
            quantityMinus
          ) {

            event.preventDefault();
            event.stopPropagation();


            const card =
              quantityMinus.closest(
                '.addon-card'
              );


            if (
              !card
            ) {

              return;

            }


            const current =
              this.getAddonQuantity(
                card
              );


            this.setAddonQuantity(
              card,
              current - 1
            );


            return;

          }


          const quantityPlus =
            event.target.closest(
              '[data-addon-quantity-plus]'
            );


          if (
            quantityPlus
          ) {

            event.preventDefault();
            event.stopPropagation();


            const card =
              quantityPlus.closest(
                '.addon-card'
              );


            if (
              !card
            ) {

              return;

            }


            const current =
              this.getAddonQuantity(
                card
              );


            this.setAddonQuantity(
              card,
              current + 1
            );


            return;

          }


          if (
            event.target.closest(
              '[data-addon-swatch]'
            )
          ) {

            return;

          }


          const productLink =
            event.target.closest(
              '[data-addon-product-link]'
            );


          if (
            productLink
          ) {

            event.stopPropagation();

            return;

          }


          const card =
            event.target.closest(
              '.addon-card'
            );


          if (
            !card
          ) {

            return;

          }


          if (
            card.classList.contains(
              'is-unavailable'
            ) ||
            card.getAttribute(
              'aria-disabled'
            ) === 'true'
          ) {

            return;

          }


          this.toggleCard(
            card
          );

        }
      );


      this.addEventListener(
        'keydown',
        (event) => {

          if (
            event.key !== 'Enter' &&
            event.key !== ' '
          ) {

            return;

          }


          if (
            event.target.closest(
              '[data-addon-swatch], [data-addon-quantity-minus], [data-addon-quantity-plus], [data-addon-add-button]'
            )
          ) {

            return;

          }


          const card =
            event.target.closest(
              '.addon-card'
            );


          if (
            !card
          ) {

            return;

          }


          if (
            card.classList.contains(
              'is-unavailable'
            ) ||
            card.getAttribute(
              'aria-disabled'
            ) === 'true'
          ) {

            return;

          }


          event.preventDefault();


          this.toggleCard(
            card
          );

        }
      );

    }


    /* =====================================================
       KARTE TOGGLE
       ===================================================== */

    toggleCard(card) {

      if (
        this.selectedCard ===
        card
      ) {

        this.clearSelection();

        return;

      }


      const index =
        parseInt(
          card.dataset.addonIndex,
          10
        );


      if (
        index === -1
      ) {

        this.selectCard(
          card,
          false
        );


        return;

      }


      this.selectCard(
        card,
        true
      );

    }


    /* =====================================================
       KARTE AUSWÄHLEN
       ===================================================== */

    selectCard(
      card,
      isRealAddon
    ) {

      this.selectedCard =
        card;


      this
        .querySelectorAll(
          '.addon-card'
        )
        .forEach(
          (item) => {

            const active =
              item === card;


            item.classList.toggle(
              'is-selected',
              active
            );


            item.setAttribute(
              'aria-selected',
              active
                ? 'true'
                : 'false'
            );

          }
        );


      this.disableBundleFormProperties();


      if (
        !isRealAddon
      ) {

        this.updateAddonControlsVisibility();


        return;

      }


      this.setAddonQuantity(
        card,
        this.getAddonQuantity(
          card
        )
      );


      this.updateAddonControlsVisibility();

    }


    /* =====================================================
       AUSWAHL ENTFERNEN
       ===================================================== */

    clearSelection() {

      this.selectedCard =
        null;


      this
        .querySelectorAll(
          '.addon-card'
        )
        .forEach(
          (card) => {

            card.classList.remove(
              'is-selected'
            );


            card.setAttribute(
              'aria-selected',
              'false'
            );


            const index =
              parseInt(
                card.dataset.addonIndex,
                10
              );


            if (
              !Number.isNaN(index) &&
              index >= 0
            ) {

              this.setAddonQuantity(
                card,
                ADDON_MIN_QUANTITY
              );

            }

          }
        );


      this.updateAddonControlsVisibility();


      this.disableBundleFormProperties();


      if (
        this.__pending &&
        this.__pending.bundleId
      ) {

        delete window
          .__addonPendingBundles[
            this.__pending.bundleId
          ];

      }


      this.__pending =
        null;

    }


    /* =====================================================
       AKTUELLE VARIANT-ID
       ===================================================== */

    currentVariantId() {

      if (
        !this.selectedCard
      ) {

        return null;

      }


      const index =
        parseInt(
          this.selectedCard.dataset
            .addonIndex,
          10
        );


      if (
        index < 0
      ) {

        return null;

      }


      const variantId =
        parseInt(
          this.selectedCard.getAttribute(
            'data-variant-id'
          ),
          10
        );


      return Number.isNaN(
        variantId
      )
        ? null
        : variantId;

    }


    /* =====================================================
       PFEILE
       ===================================================== */

    initArrows() {

      const row =
        this.querySelector(
          '.addon-chooser__row'
        );


      const grid =
        this.querySelector(
          '.addon-chooser__grid'
        );


      const prev =
        this.querySelector(
          '[data-addon-arrow="prev"]'
        );


      const next =
        this.querySelector(
          '[data-addon-arrow="next"]'
        );


      if (
        !row ||
        !grid ||
        !prev ||
        !next
      ) {

        return;

      }


      const update =
        () => {

          row.classList.toggle(
            'has-overflow',
            grid.scrollWidth >
              grid.clientWidth + 4
          );


          prev.classList.toggle(
            'is-edge',
            grid.scrollLeft <= 2
          );


          next.classList.toggle(
            'is-edge',
            grid.scrollLeft +
                grid.clientWidth >=
              grid.scrollWidth - 2
          );

        };


      const step =
        () =>
          Math.max(
            grid.clientWidth * 0.6,
            160
          );


      prev.addEventListener(
        'click',
        (event) => {

          event.preventDefault();

          event.stopPropagation();


          grid.scrollBy({

            left:
              -step(),

            behavior:
              'smooth'

          });

        }
      );


      next.addEventListener(
        'click',
        (event) => {

          event.preventDefault();

          event.stopPropagation();


          grid.scrollBy({

            left:
              step(),

            behavior:
              'smooth'

          });

        }
      );


      grid.addEventListener(
        'scroll',
        update,
        {
          passive: true
        }
      );


      window.addEventListener(
        'resize',
        update
      );


      requestAnimationFrame(
        update
      );


      setTimeout(
        update,
        300
      );

    }


    /* =====================================================
       FEHLER
       ===================================================== */

    showError(message) {

      const error =
        this.querySelector(
          '[data-addon-error]'
        );


      if (
        !error
      ) {

        return;

      }


      error.textContent =
        message;


      error.hidden =
        false;

    }


    clearError() {

      const error =
        this.querySelector(
          '[data-addon-error]'
        );


      if (
        !error
      ) {

        return;

      }


      error.textContent =
        '';


      error.hidden =
        true;

    }

  }


  /* =========================================================
     CUSTOM ELEMENT
     ========================================================= */

  if (
    !customElements.get(
      'addon-chooser-standalone'
    )
  ) {

    customElements.define(
      'addon-chooser-standalone',
      AddonChooserStandalone
    );

  }


  /* =========================================================
     GLOBALER SWATCH-LISTENER
     ========================================================= */

  document.addEventListener(
    'click',
    (event) => {

      const swatch =
        event.target.closest(
          '[data-addon-swatch]'
        );


      if (
        !swatch
      ) {

        return;

      }


      const chooser =
        swatch.closest(
          'addon-chooser-standalone'
        );


      const card =
        swatch.closest(
          '.addon-card'
        );


      if (
        !chooser ||
        !card
      ) {

        return;

      }


      if (
        card.classList.contains(
          'is-unavailable'
        ) ||
        card.getAttribute(
          'aria-disabled'
        ) === 'true'
      ) {

        return;

      }


      event.preventDefault();

      event.stopPropagation();


      const variantId =
        swatch.getAttribute(
          'data-variant-id'
        );


      if (
        !variantId
      ) {

        return;

      }


      card
        .querySelectorAll(
          '[data-addon-swatch]'
        )
        .forEach(
          (item) => {

            const selected =
              item === swatch;


            item.classList.toggle(
              'is-selected',
              selected
            );


            item.setAttribute(
              'aria-pressed',
              selected
                ? 'true'
                : 'false'
            );

          }
        );


      card.setAttribute(
        'data-variant-id',
        variantId
      );


      card.dataset.variantId =
        variantId;


      card.dataset.addonCartVariantId =
        variantId;


      const image =
        card.querySelector(
          '[data-addon-main-image]'
        );


      const newImage =
        swatch.getAttribute(
          'data-image'
        );


      if (
        image &&
        newImage
      ) {

        image.removeAttribute(
          'srcset'
        );


        image.removeAttribute(
          'sizes'
        );


        image.src =
          newImage;


        const image180 =
          swatch.getAttribute(
            'data-image-180'
          );


        const image300 =
          swatch.getAttribute(
            'data-image-300'
          );


        const image420 =
          swatch.getAttribute(
            'data-image-420'
          );


        if (
          image180 &&
          image300 &&
          image420
        ) {

          image.srcset =
            `${image180} 180w, ` +
            `${image300} 300w, ` +
            `${image420} 420w`;


          image.sizes =
            '(max-width: 699px) 42vw, 30vw';

        }

      }


      const price =
        card.querySelector(
          '[data-addon-price]'
        );


      const variantPrice =
        swatch.getAttribute(
          'data-variant-price'
        );


      if (
        price &&
        variantPrice
      ) {

        price.dataset.normalPrice =
          variantPrice;

      }


      if (
        typeof chooser.selectCard ===
        'function'
      ) {

        chooser.selectCard(
          card,
          true
        );

      }


      if (
        typeof chooser.updatePromo ===
        'function'
      ) {

        chooser.updatePromo();

      }

    },
    true
  );


  /* =========================================================
     SWATCH-TASTATUR
     ========================================================= */

  document.addEventListener(
    'keydown',
    (event) => {

      if (
        event.key !== 'Enter' &&
        event.key !== ' '
      ) {

        return;

      }


      const swatch =
        event.target.closest(
          '[data-addon-swatch]'
        );


      if (
        !swatch
      ) {

        return;

      }


      event.preventDefault();

      event.stopPropagation();


      swatch.click();

    },
    true
  );


  /* =========================================================
     HOODIE + AUSGEWÄHLTE CAP KOPPELN – FINALER FLOW

     Ziel:
     - Keine Cap gewählt: normaler Impact/Teeinblue-Produkt-Add.
     - 1 Hoodie + Cap: Hoodie normal hinzufügen, danach 1 Cap.
     - >1 Hoodies + Cap: einmaliges Mengen-Popup, danach Hoodie
       normal hinzufügen und anschließend gewählte Cap-Menge.

     Warum dieser Flow:
     Der alte Ansatz hing vom Theme-Event "variant:add" ab. Dieses
     Event ist im Impact/Teeinblue-Ablauf nicht zuverlässig genug.
     Deshalb beobachten wir stattdessen den echten Warenkorb über
     /cart.js und fügen die Cap erst hinzu, wenn der Hauptprodukt-Add
     dort tatsächlich sichtbar ist.
     ========================================================= */

  const addonBundleBypassForms =
    new WeakSet();


  const addonBundleProcessingForms =
    new WeakSet();


  /* =========================================================
     ZWISCHEN-POPUP VON IMPACT WÄHREND BUNDLE-ADD UNTERDRÜCKEN

     Beim nativen Hoodie-Add feuert Impact/Teeinblue ein "variant:add".
     Ohne diesen Schutz öffnet Impact bereits kurz den Warenkorb, obwohl
     die Cap noch nicht hinzugefügt wurde. Das erzeugt das sichtbare
     Aufblitzen/Zerschießen.

     Der Bundle-Flow selbst hängt NICHT von diesem Event ab, sondern
     prüft den echten Shopify-Warenkorb über /cart.js. Daher dürfen wir
     nur während eines laufenden Hoodie+Cap-Adds dieses eine Zwischen-
     Event für die Theme-UI abfangen.
     ========================================================= */

  let suppressIntermediateVariantAdded =
    false;


  document.addEventListener(
    'variant:add',
    (event) => {

      if (!suppressIntermediateVariantAdded) {

        return;

      }


      event.stopImmediatePropagation();

    },
    true
  );


  function getSelectedRealAddonCard(
    chooser
  ) {

    if (
      !chooser ||
      !chooser.selectedCard
    ) {

      return null;

    }


    const index =
      parseInt(
        chooser.selectedCard.dataset
          .addonIndex,
        10
      );


    if (
      Number.isNaN(index) ||
      index < 0
    ) {

      return null;

    }


    return chooser.selectedCard;

  }


  function getActiveChooser() {

    return Array.from(
      document.querySelectorAll(
        'addon-chooser-standalone'
      )
    ).find(
      (chooser) =>
        getSelectedRealAddonCard(
          chooser
        )
    ) || null;

  }


  function getMainVariantIdFromForm(
    form
  ) {

    if (!form) {

      return null;

    }


    const idInput =
      form.querySelector(
        'input[name="id"], select[name="id"]'
      );


    const variantId =
      parseInt(
        idInput?.value || '0',
        10
      );


    return Number.isNaN(variantId) ||
      variantId <= 0
      ? null
      : variantId;

  }


  async function getCartState() {

    const response =
      await fetch(
        `${routesRoot()}cart.js`,
        {
          method:
            'GET',
          headers: {
            'Accept':
              'application/json'
          },
          cache:
            'no-store'
        }
      );


    if (!response.ok) {

      throw new Error(
        `cart.js ${response.status}`
      );

    }


    return response.json();

  }


  function getVariantQuantityInCart(
    cart,
    variantId
  ) {

    if (
      !cart ||
      !variantId ||
      !Array.isArray(cart.items)
    ) {

      return 0;

    }


    return cart.items.reduce(
      (sum, item) => {

        const itemVariantId =
          parseInt(
            item.variant_id ||
            item.id ||
            '0',
            10
          );


        if (
          itemVariantId !== variantId
        ) {

          return sum;

        }


        return sum +
          Math.max(
            0,
            parseInt(
              item.quantity || '0',
              10
            ) || 0
          );

      },
      0
    );

  }


  async function waitForMainProductAdd({
    beforeCart,
    mainVariantId,
    mainQuantity,
    timeoutMs = 12000
  }) {

    const startedAt =
      Date.now();


    const beforeItemCount =
      Math.max(
        0,
        parseInt(
          beforeCart?.item_count || '0',
          10
        ) || 0
      );


    const beforeVariantQuantity =
      getVariantQuantityInCart(
        beforeCart,
        mainVariantId
      );


    const expectedQuantity =
      Math.max(
        1,
        parseInt(
          mainQuantity || '1',
          10
        ) || 1
      );


    while (
      Date.now() - startedAt < timeoutMs
    ) {

      await sleep(
        220
      );


      try {

        const currentCart =
          await getCartState();


        const currentItemCount =
          Math.max(
            0,
            parseInt(
              currentCart?.item_count || '0',
              10
            ) || 0
          );


        const currentVariantQuantity =
          getVariantQuantityInCart(
            currentCart,
            mainVariantId
          );


        const itemCountIncreased =
          currentItemCount >=
          beforeItemCount +
          expectedQuantity;


        const variantQuantityIncreased =
          mainVariantId &&
          currentVariantQuantity >=
          beforeVariantQuantity +
          expectedQuantity;


        if (
          itemCountIncreased ||
          variantQuantityIncreased
        ) {

          return currentCart;

        }

      } catch (_) {}

    }


    return null;

  }


  function findAddedMainCartItem({
    beforeCart,
    afterCart,
    mainVariantId
  }) {

    if (!afterCart || !Array.isArray(afterCart.items)) {
      return null;
    }

    const beforeQuantities = new Map();

    if (beforeCart && Array.isArray(beforeCart.items)) {
      beforeCart.items.forEach((item) => {
        beforeQuantities.set(
          item.key,
          Math.max(0, parseInt(item.quantity || '0', 10) || 0)
        );
      });
    }

    const candidates = afterCart.items
      .filter((item) => {
        const role = item.properties && item.properties._addon_bundle_role;
        if (role === 'addon') return false;

        const variantId = parseInt(item.variant_id || item.id || '0', 10);
        if (mainVariantId && variantId !== mainVariantId) return false;

        const beforeQuantity = beforeQuantities.get(item.key) || 0;
        const afterQuantity = Math.max(0, parseInt(item.quantity || '0', 10) || 0);
        return afterQuantity > beforeQuantity;
      })
      .sort((a, b) => {
        const aDelta = (parseInt(a.quantity || '0', 10) || 0) - (beforeQuantities.get(a.key) || 0);
        const bDelta = (parseInt(b.quantity || '0', 10) || 0) - (beforeQuantities.get(b.key) || 0);
        return bDelta - aDelta;
      });

    if (candidates.length) {
      return candidates[0];
    }

    /*
     * Fallback für Theme-/App-Flows, bei denen Shopify einen bereits
     * existierenden Line-Item-Key wiederverwendet.
     */
    if (mainVariantId) {
      return afterCart.items.find((item) => {
        const role = item.properties && item.properties._addon_bundle_role;
        const variantId = parseInt(item.variant_id || item.id || '0', 10);
        return role !== 'addon' && variantId === mainVariantId;
      }) || null;
    }

    return null;
  }


  async function attachBundlePropertiesToMainItem({
    beforeCart,
    afterCart,
    mainVariantId,
    bundleId,
    addonLabel
  }) {

    const mainItem = findAddedMainCartItem({
      beforeCart,
      afterCart,
      mainVariantId
    });

    if (!mainItem || !mainItem.key) {
      throw new Error('Neu hinzugefügter Hoodie konnte im Warenkorb nicht eindeutig gefunden werden.');
    }

    const properties = Object.assign({}, mainItem.properties || {}, {
      _addon_bundle_id: bundleId,
      _addon_bundle_role: 'main',
      _Zusatzprodukt: addonLabel || 'Zusatzprodukt'
    });

    const response = await fetch(
      `${routesRoot()}cart/change.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: mainItem.key,
          quantity: Math.max(1, parseInt(mainItem.quantity || '1', 10) || 1),
          properties
        })
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Hauptprodukt-Bundle-Markierung fehlgeschlagen: ${response.status} ${errorText}`);
    }

    return response.json();
  }


  function setMainBundleProperties(
    chooser,
    bundleId,
    addonLabel
  ) {

    if (!chooser) {

      return;

    }


    const bundleInput =
      chooser.querySelector(
        '[data-addon-prop-bundle]'
      );


    const roleInput =
      chooser.querySelector(
        '[data-addon-prop-role]'
      );


    const labelInput =
      chooser.querySelector(
        '[data-addon-prop-label]'
      );


    if (bundleInput) {

      bundleInput.value =
        bundleId;

      bundleInput.disabled =
        false;

    }


    if (roleInput) {

      roleInput.value =
        'main';

      roleInput.disabled =
        false;

    }


    if (labelInput) {

      labelInput.value =
        addonLabel ||
        'Zusatzprodukt';

      labelInput.disabled =
        false;

    }

  }


  async function addSelectedAddonToCart({
    chooser,
    quantity,
    bundleId
  }) {

    const card =
      getSelectedRealAddonCard(
        chooser
      );


    if (!card) {

      throw new Error(
        'Keine Cap ausgewählt.'
      );

    }


    const variantId =
      parseInt(
        card.getAttribute(
          'data-addon-cart-variant-id'
        ) ||
        card.getAttribute(
          'data-variant-id'
        ) ||
        card.dataset.addonCartVariantId ||
        card.dataset.variantId ||
        '0',
        10
      );


    if (
      Number.isNaN(variantId) ||
      variantId <= 0
    ) {

      throw new Error(
        'Keine gültige Cap-Variante gefunden.'
      );

    }


    const safeQuantity =
      Math.max(
        1,
        parseInt(
          quantity || '1',
          10
        ) || 1
      );


    const response =
      await fetch(
        `${routesRoot()}cart/add.js`,
        {
          method:
            'POST',
          headers: {
            'Content-Type':
              'application/json',
            'Accept':
              'application/json'
          },
          body:
            JSON.stringify({
              items: [
                {
                  id:
                    variantId,
                  quantity:
                    safeQuantity,
                  properties: {
                    _addon_bundle_id:
                      bundleId,
                    _addon_bundle_role:
                      'addon',
                    _addon_label:
                      card.dataset.addonLabel ||
                      'Zusatzprodukt',
                    _addon_source:
                      'upsell'
                  }
                }
              ],
              sections: [
                'variant-added'
              ],
              sections_url:
                window.location.pathname
            })
        }
      );


    if (!response.ok) {

      const errorText =
        await response.text();


      throw new Error(
        `Addon cart/add failed: ${response.status} ${errorText}`
      );

    }


    return response.json();

  }


  function closeAddonQuantityPopup() {

    document
      .querySelectorAll(
        '[data-addon-quantity-popup]'
      )
      .forEach(
        (popup) =>
          popup.remove()
      );


    document.documentElement
      .classList.remove(
        'addon-quantity-popup-open'
      );

  }


  function openAddonQuantityPopup({
    chooser,
    maxQuantity,
    onSelect
  }) {

    closeAddonQuantityPopup();


    if (!chooser) {

      return;

    }


    const max =
      Math.max(
        2,
        parseInt(
          maxQuantity || '2',
          10
        ) || 2
      );


    const escapeHtml =
      (value) =>
        String(value ?? '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');


    const sourceCards =
      Array.from(
        chooser.querySelectorAll(
          '.addon-card'
        )
      ).filter(
        (card) => {

          const index =
            parseInt(
              card.dataset.addonIndex || '-1',
              10
            );


          return (
            !Number.isNaN(index) &&
            index >= 0 &&
            card.getAttribute('aria-disabled') !== 'true'
          );

        }
      );


    if (!sourceCards.length) {

      return;

    }


    const popupItems =
      sourceCards.map(
        (card, index) => {

          const image =
            card.querySelector(
              '[data-addon-main-image]'
            );


          const price =
            card.querySelector(
              '[data-addon-price]'
            );


          const swatches =
            Array.from(
              card.querySelectorAll(
                '[data-addon-swatch]'
              )
            ).filter(
              (swatch) =>
                !swatch.disabled &&
                swatch.getAttribute('aria-disabled') !== 'true'
            );


          const activeSwatch =
            swatches.find(
              (swatch) =>
                swatch.classList.contains(
                  'is-selected'
                )
            ) ||
            swatches.find(
              (swatch) =>
                String(
                  swatch.getAttribute('data-variant-id') || ''
                ) ===
                String(
                  card.getAttribute('data-addon-cart-variant-id') ||
                  card.getAttribute('data-variant-id') ||
                  ''
                )
            ) ||
            swatches[0] ||
            null;


          const variantId =
            parseInt(
              activeSwatch?.getAttribute(
                'data-variant-id'
              ) ||
              card.getAttribute(
                'data-addon-cart-variant-id'
              ) ||
              card.getAttribute(
                'data-variant-id'
              ) ||
              '0',
              10
            );


          return {
            key:
              `addon-popup-item-${index}`,
            card,
            label:
              card.dataset.addonLabel ||
              card.querySelector(
                '.addon-card__label'
              )?.textContent?.trim() ||
              'Cap',
            quantities:
              new Map([
                [
                  Number.isNaN(variantId) ? 0 : variantId,
                  card === chooser.selectedCard ? 1 : 0
                ]
              ]),
            get quantity() {
              return this.quantities.get(this.variantId) || 0;
            },
            set quantity(value) {
              this.quantities.set(this.variantId, value);
            },
            variantId:
              Number.isNaN(variantId)
                ? 0
                : variantId,
            image:
              activeSwatch?.getAttribute(
                'data-image'
              ) ||
              image?.currentSrc ||
              image?.getAttribute('src') ||
              '',
            price:
              activeSwatch?.getAttribute(
                'data-variant-price'
              ) ||
              price?.dataset?.normalPrice ||
              price?.textContent?.trim() ||
              '',
            swatches:
              swatches.map(
                (swatch) => ({
                  variantId:
                    parseInt(
                      swatch.getAttribute(
                        'data-variant-id'
                      ) || '0',
                      10
                    ) || 0,
                  color:
                    swatch.getAttribute(
                      'data-color'
                    ) || '',
                  image:
                    swatch.getAttribute(
                      'data-image'
                    ) || '',
                  price:
                    swatch.getAttribute(
                      'data-variant-price'
                    ) || ''
                })
              )
          };

        }
      );


    const popup =
      document.createElement(
        'div'
      );


    popup.setAttribute(
      'data-addon-quantity-popup',
      ''
    );


    popup.innerHTML = `
      <div class="addon-bundle-popup__backdrop" data-addon-popup-close></div>
      <div class="addon-bundle-popup addon-bundle-popup--caps-grid" role="dialog" aria-modal="true" aria-labelledby="addon-bundle-popup-title">
        <button type="button" class="addon-bundle-popup__close" data-addon-popup-close aria-label="Schließen">×</button>

        <div class="addon-bundle-popup__header">
          <h3 class="addon-bundle-popup__title" id="addon-bundle-popup-title">Du hast eine Cap ausgewählt</h3>
          <p class="addon-bundle-popup__text">Zu deinen ${max} ${max === 1 ? 'Hoodie' : 'Hoodies'} kannst du bis zu ${max} ${max === 1 ? 'Cap' : 'Caps'} zum Vorteilspreis wählen.</p>
        </div>

        <div class="addon-bundle-popup__products" data-addon-popup-products>
          ${popupItems.map((item) => `
            <article class="addon-bundle-popup__product" data-addon-popup-item="${item.key}">
              <div class="addon-bundle-popup__media">
                ${item.image ? `<img class="addon-bundle-popup__image" data-addon-popup-image src="${escapeHtml(item.image)}" alt="${escapeHtml(item.label)}">` : ''}
              </div>

              <div class="addon-bundle-popup__product-body">
                <div class="addon-bundle-popup__product-title">${escapeHtml(item.label)}</div>

                ${item.swatches.length ? `
                  <div class="addon-bundle-popup__swatches" aria-label="Farbe auswählen">
                    ${item.swatches.map((swatch) => `
                      <button
                        type="button"
                        class="addon-bundle-popup__swatch${swatch.variantId === item.variantId ? ' is-selected' : ''}"
                        data-addon-popup-swatch
                        data-addon-popup-item-key="${item.key}"
                        data-variant-id="${swatch.variantId}"
                        data-color="${escapeHtml(swatch.color)}"
                        data-image="${escapeHtml(swatch.image)}"
                        data-price="${escapeHtml(swatch.price)}"
                        aria-label="${escapeHtml(swatch.color || 'Farbe')}"
                        title="${escapeHtml(swatch.color || 'Farbe')}"
                      >
                        <span class="addon-bundle-popup__swatch-dot"></span>
                      </button>
                    `).join('')}
                  </div>
                ` : ''}

                <div class="addon-bundle-popup__product-bottom">
                  <div class="addon-bundle-popup__price" data-addon-popup-price>${escapeHtml(item.price)}</div>

                  <div class="addon-bundle-popup__quantity" aria-label="Menge ${escapeHtml(item.label)}">
                    <button type="button" class="addon-bundle-popup__qty-btn" data-addon-popup-minus="${item.key}" aria-label="Menge verringern">−</button>
                    <span class="addon-bundle-popup__qty-value" data-addon-popup-qty="${item.key}">${item.quantity}</span>
                    <button type="button" class="addon-bundle-popup__qty-btn" data-addon-popup-plus="${item.key}" aria-label="Menge erhöhen">+</button>
                  </div>
                </div>
              </div>
            </article>
          `).join('')}
        </div>

        <div class="addon-bundle-popup__footer">
          <p class="addon-bundle-popup__limit" data-addon-popup-limit>Maximal ${max} ${max === 1 ? 'Cap' : 'Caps'} bei ${max} ${max === 1 ? 'Hoodie' : 'Hoodies'}.</p>
          <button type="button" class="addon-bundle-popup__confirm" data-addon-popup-confirm>
            Auswahl übernehmen
          </button>
        </div>
      </div>
    `;


    const style =
      document.createElement(
        'style'
      );


    style.textContent = `
      [data-addon-quantity-popup] {
        position: fixed;
        inset: 0;
        z-index: 999999;
        display: grid;
        place-items: center;
        padding: 24px;
      }

      .addon-bundle-popup__backdrop {
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.46);
        backdrop-filter: blur(3px);
      }

      .addon-bundle-popup--caps-grid {
        
        font-family: "Cabin", sans-serif;
position: relative;
        z-index: 1;
        width: min(1480px, calc(100vw - 40px));
        max-height: calc(100vh - 48px);
        overflow: auto;
        background: #fff;
        color: #2b2b2b;
        border-radius: 2px;
        padding: 34px 30px 26px;
        box-shadow: 0 28px 90px rgba(0,0,0,.24);
        text-align: center;
      }

      
      .addon-bundle-popup--caps-grid,
      .addon-bundle-popup--caps-grid *,
      .addon-bundle-popup--caps-grid button,
      .addon-bundle-popup--caps-grid input,
      .addon-bundle-popup--caps-grid select,
      .addon-bundle-popup--caps-grid textarea {
        font-family: "Cabin", sans-serif !important;
      }

      .addon-bundle-popup__close {
        position: absolute;
        top: 14px;
        right: 18px;
        width: 40px;
        height: 40px;
        padding: 0;
        border: 1px solid rgba(43,43,43,.22);
        border-radius: 0;
        background: transparent;
        color: inherit;
        font-size: 28px;
        line-height: 1;
        display: grid;
        place-items: center;
        cursor: pointer;
      }

      .addon-bundle-popup__header {
        margin: 0 auto 22px;
      }

      .addon-bundle-popup__eyebrow {
        margin: 0 0 7px;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: .22em;
        text-transform: uppercase;
        opacity: .58;
      }

      .addon-bundle-popup__title {
        margin: 0 48px 8px;
        font-size: clamp(25px, 3vw, 38px);
        line-height: 1.08;
        font-weight: 700;
      }

      .addon-bundle-popup__text {
        margin: 0;
        font-size: 15px;
        line-height: 1.45;
        opacity: .74;
      }

      .addon-bundle-popup__products {
        display: grid;
        grid-template-columns: repeat(4, minmax(245px, 1fr));
        gap: 16px;
        align-items: stretch;
      }

      .addon-bundle-popup__product {
        min-width: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        background: #fff;
        border: 1px solid rgba(43,43,43,.12);
        border-radius: 0;
        text-align: left;
      }

      .addon-bundle-popup__media {
        aspect-ratio: 1.06 / 1;
        display: grid;
        place-items: center;
        background: #fbfaf8;
        overflow: hidden;
      }

      .addon-bundle-popup__image {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
      }

      .addon-bundle-popup__product-body {
        display: flex;
        flex-direction: column;
        flex: 1;
        padding: 16px;
      }

      .addon-bundle-popup__product-title {
        min-height: 40px;
        font-size: 16px;
        line-height: 1.2;
        font-weight: 700;
      }

      .addon-bundle-popup__swatches {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 10px;
      }

      .addon-bundle-popup__swatch {
        width: 22px;
        height: 22px;
        padding: 3px;
        border-radius: 0;
        border: 1px solid rgba(43,43,43,.22);
        background: #fff;
        cursor: pointer;
      }

      .addon-bundle-popup__swatch.is-selected {
        border-color: #2b2b2b;
        box-shadow: 0 0 0 1px #2b2b2b;
      }

      .addon-bundle-popup__swatch-dot {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 999px;
        background: #b8b8b8;
      }

      .addon-bundle-popup__swatch[data-color*="Schwarz" i] .addon-bundle-popup__swatch-dot,
      .addon-bundle-popup__swatch[data-color*="Black" i] .addon-bundle-popup__swatch-dot {
        background: #171717;
      }

      .addon-bundle-popup__swatch[data-color*="Grau" i] .addon-bundle-popup__swatch-dot,
      .addon-bundle-popup__swatch[data-color*="Grey" i] .addon-bundle-popup__swatch-dot,
      .addon-bundle-popup__swatch[data-color*="Gray" i] .addon-bundle-popup__swatch-dot {
        background: #aaa9a6;
      }

      .addon-bundle-popup__swatch[data-color*="Olive" i] .addon-bundle-popup__swatch-dot {
        background: #77785d;
      }

      .addon-bundle-popup__swatch[data-color*="Denim" i] .addon-bundle-popup__swatch-dot,
      .addon-bundle-popup__swatch[data-color*="Blau" i] .addon-bundle-popup__swatch-dot,
      .addon-bundle-popup__swatch[data-color*="Blue" i] .addon-bundle-popup__swatch-dot {
        background: #657b89;
      }

      .addon-bundle-popup__product-bottom {
        margin-top: auto;
        padding-top: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
      }

      .addon-bundle-popup__price {
        font-size: 16px;
        font-weight: 700;
        white-space: nowrap;
      }

      .addon-bundle-popup__quantity {
        display: inline-grid;
        grid-template-columns: 38px 34px 38px;
        align-items: center;
        justify-items: center;
        min-height: 38px;
        border: 1px solid rgba(43,43,43,.22);
        border-radius: 0;
        overflow: hidden;
        background: #fff;
      }

      .addon-bundle-popup__qty-btn {
        width: 38px;
        height: 38px;
        padding: 0;
        border: 0;
        background: transparent;
        color: #2b2b2b;
        font: inherit;
        font-size: 20px;
        line-height: 1;
        text-align: center;
        display: grid;
        place-items: center;
        cursor: pointer;
      }

      .addon-bundle-popup__qty-btn:disabled {
        opacity: .25;
        cursor: default;
      }

      .addon-bundle-popup__qty-value {
        width: 34px;
        min-width: 34px;
        text-align: center;
        font-size: 14px;
        line-height: 1;
        font-weight: 700;
        display: grid;
        place-items: center;
      }

      .addon-bundle-popup__footer {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
      }

      .addon-bundle-popup__limit {
        margin: 0;
        font-size: 13px;
        opacity: .66;
        text-align: left;
      }

      .addon-bundle-popup__confirm {
        min-width: 230px;
        min-height: 48px;
        padding: 0 22px;
        border: 1px solid #2b2b2b;
        border-radius: 0;
        background: #2b2b2b;
        color: #fff;
        font: inherit;
        font-weight: 700;
        cursor: pointer;
      }

      .addon-bundle-popup__confirm:disabled {
        opacity: .4;
        cursor: default;
      }

      @media (max-width: 1099px) {
        .addon-bundle-popup--caps-grid {
          width: calc(100vw - 28px);
          padding: 30px 20px 22px;
        }

        .addon-bundle-popup__products {
          display: flex;
          overflow-x: auto;
          gap: 14px;
          scroll-snap-type: x mandatory;
          padding-bottom: 6px;
        }

        .addon-bundle-popup__product {
          flex: 0 0 280px;
          scroll-snap-align: start;
        }
      }

      @media (max-width: 599px) {
        [data-addon-quantity-popup] {
          padding: 10px;
        }

        .addon-bundle-popup--caps-grid {
          width: calc(100vw - 20px);
          max-height: calc(100vh - 20px);
          padding: 28px 14px 18px;
          border-radius: 0;
        }

        .addon-bundle-popup__title {
          margin-inline: 30px;
          font-size: 25px;
        }

        .addon-bundle-popup__text {
          font-size: 14px;
        }

        .addon-bundle-popup__products {
          display: flex;
          overflow-x: auto;
          gap: 10px;
          scroll-snap-type: x mandatory;
          padding-bottom: 4px;
        }

        .addon-bundle-popup__product {
          flex: 0 0 78vw;
          scroll-snap-align: start;
        }

        .addon-bundle-popup__footer {
          flex-direction: column;
          align-items: stretch;
        }

        .addon-bundle-popup__limit {
          text-align: center;
        }

        .addon-bundle-popup__confirm {
          width: 100%;
        }
      }
    
      @media (max-width: 699px) {
        [data-addon-quantity-popup] {
          display: grid !important;
          place-items: center !important;
          padding: 18px !important;
          overflow: hidden !important;
        }

        .addon-bundle-popup__backdrop {
          background: rgba(0, 0, 0, 0.28) !important;
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
        }

        .addon-bundle-popup--caps-grid {
          position: relative !important;
          width: min(92vw, 420px) !important;
          max-width: 420px !important;
          height: auto !important;
          max-height: 84vh !important;
          margin: 0 !important;
          padding: 20px 16px 16px !important;
          border-radius: 22px !important;
          background: #fff !important;
          box-shadow: 0 24px 70px rgba(0, 0, 0, 0.24) !important;
          overflow-y: auto !important;
          overflow-x: hidden !important;
          text-align: center !important;
          -webkit-overflow-scrolling: touch;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__header {
          padding: 0 8px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__title {
          margin-left: 18px !important;
          margin-right: 18px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__products,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__cards,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__choices {
          display: flex !important;
          flex-wrap: nowrap !important;
          gap: 12px !important;
          overflow-x: auto !important;
          overflow-y: visible !important;
          scroll-snap-type: x mandatory;
          padding: 2px 2px 10px !important;
          margin-left: 0 !important;
          margin-right: 0 !important;
          -webkit-overflow-scrolling: touch;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__product,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__card,
        .addon-bundle-popup--caps-grid .addon-card {
          flex: 0 0 min(72vw, 250px) !important;
          width: min(72vw, 250px) !important;
          min-width: min(72vw, 250px) !important;
          max-width: 250px !important;
          scroll-snap-align: center;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__actions,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__footer {
          position: static !important;
          margin-top: 12px !important;
          padding-top: 0 !important;
          background: transparent !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__close {
          top: 10px !important;
          right: 10px !important;
        }
      }


      /* =========================================================
         KOMPAKTES MOBILE-MODAL – ALLES OHNE SCROLLEN SICHTBAR
         ========================================================= */
      @media (max-width: 699px) {
        [data-addon-quantity-popup] {
          display: grid !important;
          place-items: center !important;
          padding: 12px !important;
          overflow: hidden !important;
        }

        .addon-bundle-popup__backdrop {
          background: rgba(0, 0, 0, 0.24) !important;
          backdrop-filter: blur(7px) !important;
          -webkit-backdrop-filter: blur(7px) !important;
        }

        .addon-bundle-popup--caps-grid {
          width: min(82vw, 330px) !important;
          max-width: 330px !important;
          height: auto !important;
          max-height: none !important;
          margin: 0 !important;
          padding: 15px 12px 12px !important;
          border-radius: 18px !important;
          background: #fff !important;
          box-shadow: 0 18px 55px rgba(0, 0, 0, 0.22) !important;
          overflow: visible !important;
          text-align: center !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__close {
          top: 7px !important;
          right: 7px !important;
          width: 28px !important;
          height: 28px !important;
          min-width: 28px !important;
          min-height: 28px !important;
          padding: 0 !important;
          font-size: 20px !important;
          line-height: 1 !important;
          display: grid !important;
          place-items: center !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__header {
          padding: 0 24px 0 24px !important;
          margin: 0 0 10px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__title {
          margin: 0 0 4px !important;
          font-size: 17px !important;
          line-height: 1.15 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__text {
          margin: 0 !important;
          font-size: 11px !important;
          line-height: 1.25 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__products,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__cards,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__choices {
          display: grid !important;
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          gap: 8px !important;
          width: 100% !important;
          overflow: visible !important;
          padding: 0 !important;
          margin: 0 !important;
          scroll-snap-type: none !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__product,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__card,
        .addon-bundle-popup--caps-grid .addon-card {
          width: 100% !important;
          min-width: 0 !important;
          max-width: none !important;
          flex: none !important;
          scroll-snap-align: none !important;
          padding: 7px !important;
          margin: 0 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__media {
          height: 78px !important;
          min-height: 78px !important;
          margin: 0 0 5px !important;
          padding: 0 !important;
          overflow: hidden !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__image {
          width: 100% !important;
          height: 100% !important;
          object-fit: contain !important;
          display: block !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__product-body {
          padding: 0 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__product-title {
          margin: 0 0 4px !important;
          font-size: 11px !important;
          line-height: 1.15 !important;
          font-weight: 700 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__swatches {
          display: flex !important;
          justify-content: center !important;
          align-items: center !important;
          gap: 4px !important;
          margin: 0 0 4px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch {
          width: 18px !important;
          height: 18px !important;
          min-width: 18px !important;
          min-height: 18px !important;
          padding: 2px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch-dot {
          width: 10px !important;
          height: 10px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__product-bottom {
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          gap: 5px !important;
          margin: 0 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__price {
          font-size: 11px !important;
          line-height: 1 !important;
          margin: 0 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__quantity {
          width: 88px !important;
          min-width: 88px !important;
          height: 28px !important;
          min-height: 28px !important;
          display: grid !important;
          grid-template-columns: 28px 32px 28px !important;
          align-items: center !important;
          justify-content: center !important;
          margin: 0 auto !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__qty-btn {
          width: 28px !important;
          height: 28px !important;
          min-width: 28px !important;
          min-height: 28px !important;
          padding: 0 !important;
          font-size: 16px !important;
          line-height: 1 !important;
          display: grid !important;
          place-items: center !important;
          text-align: center !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__qty-value {
          width: 32px !important;
          min-width: 32px !important;
          height: 28px !important;
          min-height: 28px !important;
          padding: 0 !important;
          font-size: 11px !important;
          line-height: 1 !important;
          display: grid !important;
          place-items: center !important;
          text-align: center !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__footer {
          position: static !important;
          display: block !important;
          margin: 10px 0 0 !important;
          padding: 0 !important;
          background: transparent !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__limit {
          margin: 0 0 7px !important;
          font-size: 10px !important;
          line-height: 1.2 !important;
          text-align: center !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__confirm {
          width: 100% !important;
          min-height: 34px !important;
          height: 34px !important;
          padding: 0 12px !important;
          font-size: 11px !important;
          line-height: 1 !important;
        }
      }


      /* =========================================================
         MOBILE FINAL: HORIZONTALER SWIPE-STREIFEN
         Desktop bleibt unverändert.
         ========================================================= */
      @media (max-width: 699px) {
        [data-addon-quantity-popup] {
          display: grid !important;
          place-items: center !important;
          padding: 8px !important;
          overflow: hidden !important;
        }

        .addon-bundle-popup__backdrop {
          background: rgba(0, 0, 0, 0.24) !important;
          backdrop-filter: blur(7px) !important;
          -webkit-backdrop-filter: blur(7px) !important;
        }

        .addon-bundle-popup--caps-grid {
          width: calc(100vw - 16px) !important;
          max-width: none !important;
          height: auto !important;
          max-height: none !important;
          margin: 0 !important;
          padding: 14px 12px 12px !important;
          border-radius: 18px !important;
          background: #fff !important;
          box-shadow: 0 18px 55px rgba(0, 0, 0, 0.22) !important;
          overflow: hidden !important;
          text-align: center !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__close {
          top: 7px !important;
          right: 7px !important;
          width: 28px !important;
          height: 28px !important;
          min-width: 28px !important;
          min-height: 28px !important;
          padding: 0 !important;
          font-size: 20px !important;
          line-height: 1 !important;
          display: grid !important;
          place-items: center !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__header {
          padding: 0 28px !important;
          margin: 0 0 9px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__title {
          margin: 0 0 3px !important;
          font-size: 18px !important;
          line-height: 1.15 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__text {
          margin: 0 !important;
          font-size: 11px !important;
          line-height: 1.25 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__products,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__cards,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__choices {
          display: flex !important;
          flex-wrap: nowrap !important;
          gap: 10px !important;
          width: 100% !important;
          overflow-x: auto !important;
          overflow-y: hidden !important;
          scroll-snap-type: x mandatory !important;
          overscroll-behavior-x: contain;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: none;
          padding: 0 8px 6px !important;
          margin: 0 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__products::-webkit-scrollbar,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__cards::-webkit-scrollbar,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__choices::-webkit-scrollbar {
          display: none;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__product,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__card,
        .addon-bundle-popup--caps-grid .addon-card {
          flex: 0 0 74vw !important;
          width: 74vw !important;
          min-width: 74vw !important;
          max-width: 300px !important;
          scroll-snap-align: center !important;
          padding: 10px !important;
          margin: 0 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__media {
          height: 155px !important;
          min-height: 155px !important;
          margin: 0 0 7px !important;
          padding: 0 !important;
          overflow: hidden !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__image {
          width: 100% !important;
          height: 100% !important;
          object-fit: contain !important;
          display: block !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__product-body {
          padding: 0 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__product-title {
          margin: 0 0 5px !important;
          font-size: 13px !important;
          line-height: 1.15 !important;
          font-weight: 700 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__swatches {
          display: flex !important;
          justify-content: center !important;
          align-items: center !important;
          gap: 5px !important;
          margin: 0 0 5px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch {
          width: 22px !important;
          height: 22px !important;
          min-width: 22px !important;
          min-height: 22px !important;
          padding: 2px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch-dot {
          width: 12px !important;
          height: 12px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__product-bottom {
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          gap: 6px !important;
          margin: 0 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__price {
          font-size: 12px !important;
          line-height: 1 !important;
          margin: 0 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__quantity {
          width: 98px !important;
          min-width: 98px !important;
          height: 32px !important;
          min-height: 32px !important;
          display: grid !important;
          grid-template-columns: 32px 34px 32px !important;
          align-items: center !important;
          justify-content: center !important;
          margin: 0 auto !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__qty-btn {
          width: 32px !important;
          height: 32px !important;
          min-width: 32px !important;
          min-height: 32px !important;
          padding: 0 !important;
          font-size: 17px !important;
          line-height: 1 !important;
          display: grid !important;
          place-items: center !important;
          text-align: center !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__qty-value {
          width: 34px !important;
          min-width: 34px !important;
          height: 32px !important;
          min-height: 32px !important;
          padding: 0 !important;
          font-size: 12px !important;
          line-height: 1 !important;
          display: grid !important;
          place-items: center !important;
          text-align: center !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__footer {
          position: static !important;
          display: block !important;
          margin: 8px 0 0 !important;
          padding: 0 !important;
          background: transparent !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__limit {
          margin: 0 0 6px !important;
          font-size: 10px !important;
          line-height: 1.2 !important;
          text-align: center !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__confirm {
          width: 100% !important;
          min-height: 36px !important;
          height: 36px !important;
          padding: 0 12px !important;
          font-size: 11px !important;
          line-height: 1 !important;
        }
      }


      /* =========================================================
         MOBILE FEINSCHLIFF:
         - Farbswatches exakt zentriert
         - Produktbilder füllen den Bildbereich deutlich stärker
         ========================================================= */
      @media (max-width: 699px) {
        .addon-bundle-popup--caps-grid .addon-bundle-popup__swatches {
          display: flex !important;
          justify-content: center !important;
          align-items: center !important;
          gap: 6px !important;
          width: 100% !important;
          margin-left: auto !important;
          margin-right: auto !important;
          text-align: center !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch {
          display: grid !important;
          place-items: center !important;
          padding: 0 !important;
          margin: 0 !important;
          box-sizing: border-box !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch-dot {
          display: block !important;
          margin: 0 auto !important;
          align-self: center !important;
          justify-self: center !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__media {
          height: 190px !important;
          min-height: 190px !important;
          padding: 0 !important;
          margin: 0 0 8px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          overflow: hidden !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__image {
          width: 100% !important;
          height: 100% !important;
          max-width: none !important;
          max-height: none !important;
          object-fit: cover !important;
          object-position: center !important;
          display: block !important;
          transform: scale(1.08);
          transform-origin: center center;
        }
      }


      /* =========================================================
         MOBILE FEINSCHLIFF 2:
         - Modal etwas höher / luftiger
         - Produktbilder bleiben groß
         - Footer / Mengenhinweis bekommt mehr Platz
         - Nicht ganz fullscreen
         ========================================================= */
      @media (max-width: 699px) {
        .addon-bundle-popup--caps-grid {
          min-height: 78vh !important;
          max-height: 88vh !important;
          padding-top: 18px !important;
          padding-bottom: 16px !important;
          display: flex !important;
          flex-direction: column !important;
          justify-content: flex-start !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__header {
          margin-bottom: 12px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__products,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__cards,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__choices {
          margin-top: 2px !important;
          margin-bottom: 8px !important;
          padding-bottom: 8px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__footer {
          margin-top: auto !important;
          padding-top: 12px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__limit {
          margin-bottom: 10px !important;
          font-size: 11px !important;
          line-height: 1.3 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__confirm {
          min-height: 40px !important;
          height: 40px !important;
          font-size: 12px !important;
        }
      }


      /* =========================================================
         MOBILE FEINSCHLIFF 3:
         - Produktkarten länger / höher
         - weniger Leerraum zwischen Quantity Picker und Footer
         - Produktbilder vollständig sichtbar, nicht abgeschnitten
         ========================================================= */
      @media (max-width: 699px) {
        .addon-bundle-popup--caps-grid .addon-bundle-popup__products,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__cards,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__choices {
          align-items: stretch !important;
          margin-bottom: 4px !important;
          padding-bottom: 4px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__product,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__card,
        .addon-bundle-popup--caps-grid .addon-card {
          min-height: 360px !important;
          height: 360px !important;
          display: flex !important;
          flex-direction: column !important;
          justify-content: flex-start !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__media {
          height: 205px !important;
          min-height: 205px !important;
          max-height: 205px !important;
          padding: 4px 6px !important;
          margin: 0 0 8px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          overflow: hidden !important;
          box-sizing: border-box !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__image {
          width: 100% !important;
          height: 100% !important;
          max-width: 100% !important;
          max-height: 100% !important;
          object-fit: contain !important;
          object-position: center center !important;
          transform: none !important;
          display: block !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__product-body {
          flex: 1 1 auto !important;
          display: flex !important;
          flex-direction: column !important;
          padding: 0 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__product-bottom {
          margin-top: auto !important;
          padding-top: 6px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__footer {
          margin-top: 6px !important;
          padding-top: 6px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__limit {
          margin-bottom: 8px !important;
        }
      }


      /* =========================================================
         MOBILE FINAL:
         - Produktbild-GRÖSSE bleibt unverändert
         - Produktbild exakt mittig
         - kompletter Popup-/Karten-/Bild-Hintergrund weiß
         - Footer etwas weiter nach unten
         ========================================================= */
      @media (max-width: 699px) {
        .addon-bundle-popup--caps-grid {
          background: #fff !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__product,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__card,
        .addon-bundle-popup--caps-grid .addon-card,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__product-body,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__product-bottom,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__footer {
          background: #fff !important;
        }

        /* Bildbereich: gleiche Größe wie zuvor, nur sauber weiß + zentriert */
        .addon-bundle-popup--caps-grid .addon-bundle-popup__media {
          height: 205px !important;
          min-height: 205px !important;
          max-height: 205px !important;
          padding: 4px 6px !important;
          margin: 0 0 8px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          background: #fff !important;
          overflow: hidden !important;
          box-sizing: border-box !important;
          text-align: center !important;
        }

        /* Produktbildgröße bewusst NICHT verkleinert */
        .addon-bundle-popup--caps-grid .addon-bundle-popup__image {
          width: 100% !important;
          height: 100% !important;
          max-width: 100% !important;
          max-height: 100% !important;
          object-fit: contain !important;
          object-position: 50% 50% !important;
          transform: none !important;
          margin: auto !important;
          align-self: center !important;
          justify-self: center !important;
          display: block !important;
          background: #fff !important;
        }

        /* Karteninhalt optisch mittig halten */
        .addon-bundle-popup--caps-grid .addon-bundle-popup__product-body {
          width: 100% !important;
          align-items: center !important;
          text-align: center !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__product-title,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__price {
          width: 100% !important;
          text-align: center !important;
        }

        /* Farbswatches ebenfalls sauber mittig */
        .addon-bundle-popup--caps-grid .addon-bundle-popup__swatches {
          width: 100% !important;
          display: flex !important;
          justify-content: center !important;
          align-items: center !important;
          margin-left: auto !important;
          margin-right: auto !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch {
          display: grid !important;
          place-items: center !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch-dot {
          margin: 0 auto !important;
          align-self: center !important;
          justify-self: center !important;
        }

        /* Kleinen Hinweis + Button wieder etwas weiter nach unten */
        .addon-bundle-popup--caps-grid .addon-bundle-popup__footer {
          margin-top: auto !important;
          padding-top: 16px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__limit {
          margin-top: 0 !important;
          margin-bottom: 10px !important;
        }
      }


      /* =========================================================
         MOBILE FINALER FEINSCHLIFF:
         - Produktbild optisch exakt mittig
         - X oben rechts ohne Rahmen / Box
         ========================================================= */
      @media (max-width: 699px) {
        .addon-bundle-popup--caps-grid .addon-bundle-popup__media {
          position: relative !important;
          display: grid !important;
          place-items: center !important;
          text-align: center !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__image {
          position: relative !important;
          inset: auto !important;
          width: 100% !important;
          height: 100% !important;
          max-width: 100% !important;
          max-height: 100% !important;
          object-fit: contain !important;
          object-position: center center !important;
          margin: 0 auto !important;
          padding: 0 !important;
          transform: none !important;
          align-self: center !important;
          justify-self: center !important;
          display: block !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__close {
          border: 0 !important;
          outline: 0 !important;
          box-shadow: none !important;
          background: transparent !important;
          border-radius: 0 !important;
          width: 28px !important;
          height: 28px !important;
          min-width: 28px !important;
          min-height: 28px !important;
          padding: 0 !important;
          display: grid !important;
          place-items: center !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__close:hover,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__close:focus,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__close:focus-visible,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__close:active {
          border: 0 !important;
          outline: 0 !important;
          box-shadow: none !important;
          background: transparent !important;
        }
      }


      /* =========================================================
         DESKTOP + MOBILE:
         Produktkarten ohne Umrandung.
         Quantity Picker bleibt unverändert.
         ========================================================= */
      .addon-bundle-popup--caps-grid .addon-bundle-popup__product,
      .addon-bundle-popup--caps-grid .addon-bundle-popup__card,
      .addon-bundle-popup--caps-grid .addon-card {
        border: 0 !important;
        outline: 0 !important;
        box-shadow: none !important;
      }


      /* =========================================================
         MOBILE:
         Nächstes Produkt leicht sichtbar ("peek"),
         damit Swipe-Geste sofort verständlich ist.
         ========================================================= */
      @media (max-width: 699px) {
        .addon-bundle-popup--caps-grid .addon-bundle-popup__products,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__cards,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__choices {
          gap: 8px !important;
          padding-left: 6px !important;
          padding-right: 24px !important;
          scroll-padding-left: 6px !important;
          scroll-padding-right: 24px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__product,
        .addon-bundle-popup--caps-grid .addon-bundle-popup__card,
        .addon-bundle-popup--caps-grid .addon-card {
          flex: 0 0 70vw !important;
          width: 70vw !important;
          min-width: 70vw !important;
          max-width: 286px !important;
        }
      }


      /* =========================================================
         FINAL:
         Gesamtes Popup-Modul eckig – Mobile + Desktop.
         ========================================================= */
      .addon-bundle-popup--caps-grid {
        border-radius: 0 !important;
      }

      @media (max-width: 699px) {
        .addon-bundle-popup--caps-grid {
          border-radius: 0 !important;
        }
      }


      /* =========================================================
         MOBILE FEINSCHLIFF:
         Überschrift + Erklärung minimal größer und etwas luftiger.
         Modulgröße bleibt unverändert.
         ========================================================= */
      @media (max-width: 699px) {
        .addon-bundle-popup--caps-grid .addon-bundle-popup__title {
          font-size: 19px !important;
          line-height: 1.18 !important;
          margin-bottom: 7px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__subtitle {
          font-size: 13px !important;
          line-height: 1.28 !important;
          margin-top: 0 !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__header {
          margin-bottom: 9px !important;
        }
      }


      /* =========================================================
         FARBSWATCHES – MOBILE + DESKTOP:
         Kein viereckiger Rahmen. Auswahl wird kreisförmig markiert.
         ========================================================= */
      .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch {
        border: 0 !important;
        outline: 0 !important;
        box-shadow: none !important;
        background: transparent !important;
        border-radius: 50% !important;
      }

      .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch:hover,
      .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch:focus,
      .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch:focus-visible {
        border: 0 !important;
        outline: 0 !important;
        box-shadow: none !important;
        background: transparent !important;
      }

      .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch-dot {
        border-radius: 50% !important;
        box-sizing: border-box !important;
      }

      .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch.is-active .addon-bundle-popup__swatch-dot,
      .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch[aria-pressed="true"] .addon-bundle-popup__swatch-dot,
      .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch[aria-checked="true"] .addon-bundle-popup__swatch-dot {
        outline: 2px solid #2b2b2b !important;
        outline-offset: 2px !important;
        border-radius: 50% !important;
      }


      /* =========================================================
         FINALER FEINSCHLIFF – SWATCHES + MOBILE ABSTÄNDE
         ========================================================= */

      /* Mobile + Desktop:
         Aktuell ausgewählte Farbe eindeutig kreisförmig markieren.
         Der Popup-Code setzt dafür die Klasse "is-selected". */
      .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch.is-selected .addon-bundle-popup__swatch-dot {
        outline: 2px solid #2b2b2b !important;
        outline-offset: 2px !important;
        border-radius: 50% !important;
      }

      /* Der äußere Button bleibt komplett unsichtbar/eckfrei. */
      .addon-bundle-popup--caps-grid .addon-bundle-popup__swatch.is-selected {
        border: 0 !important;
        outline: 0 !important;
        box-shadow: none !important;
        background: transparent !important;
      }

      /* Mobile:
         Nur minimale zusätzliche Luft für eine ruhigere Struktur. */
      @media (max-width: 699px) {
        .addon-bundle-popup--caps-grid .addon-bundle-popup__swatches {
          margin-bottom: 8px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__product-bottom {
          gap: 8px !important;
          padding-bottom: 5px !important;
        }

        .addon-bundle-popup--caps-grid .addon-bundle-popup__quantity {
          margin-bottom: 2px !important;
        }
      }
`;


    popup.appendChild(
      style
    );


    document.body.appendChild(
      popup
    );


    document.documentElement
      .classList.add(
        'addon-quantity-popup-open'
      );


    const totalQuantity =
      () =>
        popupItems.reduce(
          (sum, item) =>
            sum + Array.from(item.quantities.values()).reduce(
              (variantSum, quantity) => variantSum + quantity,
              0
            ),
          0
        );


    const updateUi =
      () => {

        const total =
          totalQuantity();


        popupItems.forEach(
          (item) => {

            const value =
              popup.querySelector(
                `[data-addon-popup-qty="${item.key}"]`
              );


            const minus =
              popup.querySelector(
                `[data-addon-popup-minus="${item.key}"]`
              );


            const plus =
              popup.querySelector(
                `[data-addon-popup-plus="${item.key}"]`
              );


            if (value) {

              value.textContent =
                String(item.quantity);

            }


            if (minus) {

              minus.disabled =
                item.quantity <= 0;

            }


            if (plus) {

              plus.disabled =
                total >= max;

            }

          }
        );


        const confirm =
          popup.querySelector(
            '[data-addon-popup-confirm]'
          );


        if (confirm) {

          confirm.disabled =
            total <= 0;


          confirm.textContent =
            total > 0
              ? `Auswahl übernehmen`
              : 'Auswahl übernehmen';

        }


        const limit =
          popup.querySelector(
            '[data-addon-popup-limit]'
          );


        if (limit) {

          limit.textContent =
            `${total} von maximal ${max} ${max === 1 ? 'Cap' : 'Caps'} ausgewählt.`;

        }

      };


    const removeKeyHandler =
      () => {

        document.removeEventListener(
          'keydown',
          onKeyDown,
          true
        );

      };


    const closePopup =
      () => {

        removeKeyHandler();

        closeAddonQuantityPopup();

      };


    popup.addEventListener(
      'click',
      (event) => {

        const swatch =
          event.target.closest(
            '[data-addon-popup-swatch]'
          );


        if (swatch) {

          event.preventDefault();


          const key =
            swatch.getAttribute(
              'data-addon-popup-item-key'
            );


          const item =
            popupItems.find(
              (candidate) =>
                candidate.key === key
            );


          if (!item) {

            return;

          }


          const variantId =
            parseInt(
              swatch.getAttribute(
                'data-variant-id'
              ) || '0',
              10
            );


          if (
            Number.isNaN(variantId) ||
            variantId <= 0
          ) {

            return;

          }


          item.variantId =
            variantId;


          const imageUrl =
            swatch.getAttribute(
              'data-image'
            ) || '';


          const priceText =
            swatch.getAttribute(
              'data-price'
            ) || '';


          const itemElement =
            popup.querySelector(
              `[data-addon-popup-item="${item.key}"]`
            );


          itemElement
            ?.querySelectorAll(
              '[data-addon-popup-swatch]'
            )
            .forEach(
              (button) =>
                button.classList.toggle(
                  'is-selected',
                  button === swatch
                )
            );


          if (imageUrl) {

            const popupImage =
              itemElement?.querySelector(
                '[data-addon-popup-image]'
              );


            if (popupImage) {

              popupImage.src =
                imageUrl;

            }

          }


          if (priceText) {

            const popupPrice =
              itemElement?.querySelector(
                '[data-addon-popup-price]'
              );


            if (popupPrice) {

              popupPrice.textContent =
                priceText;

            }

          }


          item.card.setAttribute(
            'data-variant-id',
            String(variantId)
          );

          item.card.setAttribute(
            'data-addon-cart-variant-id',
            String(variantId)
          );

          item.card.dataset.variantId =
            String(variantId);

          item.card.dataset.addonCartVariantId =
            String(variantId);


          updateUi();


          return;

        }


        const minus =
          event.target.closest(
            '[data-addon-popup-minus]'
          );


        if (minus) {

          const key =
            minus.getAttribute(
              'data-addon-popup-minus'
            );


          const item =
            popupItems.find(
              (candidate) =>
                candidate.key === key
            );


          if (
            item &&
            item.quantity > 0
          ) {

            item.quantity -= 1;

            updateUi();

          }


          return;

        }


        const plus =
          event.target.closest(
            '[data-addon-popup-plus]'
          );


        if (plus) {

          const key =
            plus.getAttribute(
              'data-addon-popup-plus'
            );


          const item =
            popupItems.find(
              (candidate) =>
                candidate.key === key
            );


          if (
            item &&
            totalQuantity() < max
          ) {

            item.quantity += 1;

            updateUi();

          }


          return;

        }


        const confirm =
          event.target.closest(
            '[data-addon-popup-confirm]'
          );


        if (confirm) {

          const selection =
            popupItems.flatMap(
              (item) =>
                Array.from(item.quantities.entries())
                  .filter(
                    ([variantId, quantity]) =>
                      quantity > 0 && variantId > 0
                  )
                  .map(
                    ([variantId, quantity]) => ({
                      variantId,
                      quantity,
                      addonLabel:
                        item.label
                    })
                  )
            );


          if (!selection.length) {

            return;

          }


          closePopup();

          onSelect?.(
            selection
          );


          return;

        }


        if (
          event.target.closest(
            '[data-addon-popup-close]'
          )
        ) {

          closePopup();

        }

      }
    );


    const onKeyDown =
      (event) => {

        if (
          event.key === 'Escape'
        ) {

          closePopup();

        }

      };


    document.addEventListener(
      'keydown',
      onKeyDown,
      true
    );


    updateUi();


    popup
      .querySelector(
        '[data-addon-popup-confirm]'
      )
      ?.focus();

  }


  function isMainProductSubmitButton(
    button
  ) {

    if (!button) {

      return false;

    }


    const form =
      button.form ||
      button.closest?.(
        'form'
      );


    const productForm =
      findProductForm();


    return Boolean(
      form &&
      productForm &&
      form === productForm
    );

  }


  async function addSnapshottedAddonToCart({
    variantId,
    quantity,
    addonLabel
  }) {

    const safeVariantId =
      parseInt(
        variantId || '0',
        10
      );


    if (
      Number.isNaN(safeVariantId) ||
      safeVariantId <= 0
    ) {

      throw new Error(
        'Keine gültige Cap-Varianten-ID vorhanden.'
      );

    }


    const safeQuantity =
      Math.max(
        1,
        parseInt(
          quantity || '1',
          10
        ) || 1
      );


    const response =
      await fetch(
        `${routesRoot()}cart/add.js`,
        {
          method:
            'POST',

          headers: {
            'Content-Type':
              'application/json',
            'Accept':
              'application/json'
          },

          body:
            JSON.stringify({
              items: [
                {
                  id:
                    safeVariantId,
                  quantity:
                    safeQuantity,
                  properties: {
                    _Zusatzprodukt:
                      addonLabel ||
                      'Zusatzprodukt',
                    _addon_source:
                      'upsell'
                  }
                }
              ],
              sections: [
                'variant-added'
              ],
              sections_url:
                window.location.pathname
            })
        }
      );


    const responseText =
      await response.text();


    let responseJson = null;


    try {

      responseJson =
        responseText
          ? JSON.parse(responseText)
          : null;

    } catch (_) {}


    if (!response.ok) {

      throw new Error(
        `Cap cart/add fehlgeschlagen: ${response.status} ${responseText}`
      );

    }


    return responseJson || {};

  }


  async function addSnapshottedAddonsToCart(
    addons
  ) {

    const safeAddons =
      Array.isArray(addons)
        ? addons
            .map(
              (addon) => ({
                variantId:
                  parseInt(
                    addon?.variantId || '0',
                    10
                  ),
                quantity:
                  Math.max(
                    0,
                    parseInt(
                      addon?.quantity || '0',
                      10
                    ) || 0
                  ),
                addonLabel:
                  addon?.addonLabel ||
                  'Zusatzprodukt'
              })
            )
            .filter(
              (addon) =>
                !Number.isNaN(
                  addon.variantId
                ) &&
                addon.variantId > 0 &&
                addon.quantity > 0
            )
        : [];


    if (!safeAddons.length) {

      throw new Error(
        'Keine gültigen Cap-Varianten vorhanden.'
      );

    }


    const response =
      await fetch(
        `${routesRoot()}cart/add.js`,
        {
          method:
            'POST',

          headers: {
            'Content-Type':
              'application/json',
            'Accept':
              'application/json'
          },

          body:
            JSON.stringify({
              items:
                safeAddons.map(
                  (addon) => ({
                    id:
                      addon.variantId,
                    quantity:
                      addon.quantity,
                    properties: {
                      _Zusatzprodukt:
                        addon.addonLabel,
                      _addon_source:
                        'upsell'
                    }
                  })
                ),
              sections: [
                'variant-added'
              ],
              sections_url:
                window.location.pathname
            })
        }
      );


    const responseText =
      await response.text();


    let responseJson =
      null;


    try {

      responseJson =
        responseText
          ? JSON.parse(
              responseText
            )
          : null;

    } catch (_) {}


    if (!response.ok) {

      throw new Error(
        `Caps cart/add fehlgeschlagen: ${response.status} ${responseText}`
      );

    }


    return responseJson || {};

  }


  async function runMultiAddonBundlePurchase({
    chooser,
    form,
    submitter,
    addons
  }) {

    if (
      !chooser ||
      !form ||
      !submitter ||
      addonBundleProcessingForms.has(
        form
      )
    ) {

      return;

    }


    const mainQuantity =
      getMainQuantity();


    const safeAddons =
      Array.isArray(addons)
        ? addons
            .map(
              (addon) => ({
                variantId:
                  parseInt(
                    addon?.variantId || '0',
                    10
                  ),
                quantity:
                  Math.max(
                    0,
                    parseInt(
                      addon?.quantity || '0',
                      10
                    ) || 0
                  ),
                addonLabel:
                  addon?.addonLabel ||
                  'Cap'
              })
            )
            .filter(
              (addon) =>
                !Number.isNaN(
                  addon.variantId
                ) &&
                addon.variantId > 0 &&
                addon.quantity > 0
            )
        : [];


    const totalAddonQuantity =
      safeAddons.reduce(
        (sum, addon) =>
          sum + addon.quantity,
        0
      );


    if (
      !safeAddons.length ||
      totalAddonQuantity <= 0 ||
      totalAddonQuantity > mainQuantity
    ) {

      chooser.showError?.(
        chooser.dataset.textAddError ||
        'Die ausgewählten Caps konnten nicht erkannt werden.'
      );

      return;

    }


    const mainVariantId =
      getMainVariantIdFromForm(
        form
      );


    addonBundleProcessingForms.add(
      form
    );


    chooser.clearError?.();


    try {

      const beforeCart =
        await getCartState();


      chooser.disableBundleFormProperties?.();


      suppressIntermediateVariantAdded =
        true;


      addonBundleBypassForms.add(
        form
      );


      try {

        submitter.click();

      } finally {

        addonBundleBypassForms.delete(
          form
        );

      }


      const mainWasAdded =
        await waitForMainProductAdd({
          beforeCart,
          mainVariantId,
          mainQuantity
        });


      if (!mainWasAdded) {

        console.warn(
          '[Addon Chooser] Hauptprodukt wurde nicht im Warenkorb erkannt. Caps werden zum Schutz nicht separat hinzugefügt.'
        );

        suppressIntermediateVariantAdded =
          false;

        refreshCart();

        return;

      }


      const responseJson =
        await addSnapshottedAddonsToCart(
          safeAddons
        );


      await sleep(
        120
      );


      suppressIntermediateVariantAdded =
        false;


      showVariantAddedPopup(
        responseJson
          ?.sections
          ?.['variant-added'] ||
        ''
      );


      setTimeout(
        refreshCart,
        180
      );


      console.info(
        '[Addon Chooser] Caps erfolgreich hinzugefügt:',
        safeAddons
      );

    } catch (error) {

      console.error(
        '[Addon Chooser] Hoodie + Caps Ablauf fehlgeschlagen:',
        error
      );


      chooser.showError?.(
        chooser.dataset
          .textAddError ||
        'Die Caps konnten nicht hinzugefügt werden. Bitte versuche es erneut.'
      );


      suppressIntermediateVariantAdded =
        false;

      refreshCart();

    } finally {

      suppressIntermediateVariantAdded =
        false;

      chooser.disableBundleFormProperties?.();

      addonBundleProcessingForms.delete(
        form
      );

    }

  }


  async function runBundlePurchase({
    chooser,
    form,
    submitter,
    addonQuantity
  }) {

    if (
      !chooser ||
      !form ||
      !submitter ||
      addonBundleProcessingForms.has(
        form
      )
    ) {

      return;

    }


    const card =
      getSelectedRealAddonCard(
        chooser
      );


    if (!card) {

      return;

    }


    /*
     * WICHTIG:
     * Cap-Daten VOR dem nativen Hoodie-Add fest einfrieren.
     * Teeinblue/Impact kann danach Teile der Produktseite neu rendern.
     * Deshalb darf der spätere Cap-Add nicht mehr von einem dann evtl.
     * ersetzten DOM-Element oder chooser.selectedCard abhängen.
     */
    const snapshottedVariantId =
      parseInt(
        card.getAttribute(
          'data-addon-cart-variant-id'
        ) ||
        card.getAttribute(
          'data-variant-id'
        ) ||
        card.dataset.addonCartVariantId ||
        card.dataset.variantId ||
        '0',
        10
      );


    const snapshottedAddonLabel =
      card.dataset.addonLabel ||
      'Cap';


    if (
      Number.isNaN(snapshottedVariantId) ||
      snapshottedVariantId <= 0
    ) {

      chooser.showError?.(
        chooser.dataset.textAddError ||
        'Die ausgewählte Cap konnte nicht erkannt werden.'
      );

      console.error(
        '[Addon Chooser] Ungültige Cap-Variant-ID:',
        snapshottedVariantId
      );

      return;

    }


    const mainQuantity =
      getMainQuantity();


    const safeAddonQuantity =
      Math.min(
        mainQuantity,
        Math.max(
          1,
          parseInt(
            addonQuantity || '1',
            10
          ) || 1
        )
      );


    const mainVariantId =
      getMainVariantIdFromForm(
        form
      );


    addonBundleProcessingForms.add(
      form
    );


    chooser.clearError?.();


    try {

      const beforeCart =
        await getCartState();


      /*
       * Keine Bundle-Properties mehr an den Hoodie hängen.
       * Der Hoodie läuft exakt über seinen normalen Impact/Teeinblue-Flow.
       */
      chooser.disableBundleFormProperties?.();


      /*
       * Ab jetzt darf Impact sein Zwischen-Popup für den Hoodie NICHT
       * öffnen. Erst wenn Hoodie + Cap vollständig im Warenkorb sind,
       * zeigen wir selbst genau EIN finales variant-added-Popup.
       */
      suppressIntermediateVariantAdded =
        true;


      addonBundleBypassForms.add(
        form
      );


      try {

        submitter.click();

      } finally {

        addonBundleBypassForms.delete(
          form
        );

      }


      const mainWasAdded =
        await waitForMainProductAdd({
          beforeCart,
          mainVariantId,
          mainQuantity
        });


      if (!mainWasAdded) {

        console.warn(
          '[Addon Chooser] Hauptprodukt wurde nicht im Warenkorb erkannt. Cap wird zum Schutz nicht separat hinzugefügt.'
        );

        suppressIntermediateVariantAdded =
          false;

        refreshCart();

        return;

      }


      /*
       * Jetzt die VORHER gespeicherte Cap-Variant-ID direkt an Shopify
       * senden. Dieser Schritt hängt nicht mehr von Teeinblue, einem
       * Theme-Event oder einem nachträglich gerenderten Chooser ab.
       */
      const responseJson =
        await addSnapshottedAddonToCart({
          variantId:
            snapshottedVariantId,
          quantity:
            safeAddonQuantity,
          addonLabel:
            snapshottedAddonLabel
        });


      await sleep(
        120
      );


      /*
       * Der Hoodie+Cap-Vorgang ist jetzt vollständig. Ab hier darf die
       * normale Theme-UI wieder Events verarbeiten. Das gewünschte
       * Popup öffnen wir bewusst selbst mit der FINALEN Section aus dem
       * Cap-Add – also bereits mit Hoodie + Cap.
       */
      suppressIntermediateVariantAdded =
        false;


      showVariantAddedPopup(
        responseJson
          ?.sections
          ?.['variant-added'] ||
        ''
      );


      /*
       * Header/Cart-Counter danach synchronisieren. Etwas verzögert,
       * damit der Refresh nicht mit dem Öffnen des Popups kollidiert.
       */
      setTimeout(
        refreshCart,
        180
      );


      console.info(
        '[Addon Chooser] Cap erfolgreich hinzugefügt:',
        {
          variantId:
            snapshottedVariantId,
          quantity:
            safeAddonQuantity
        }
      );

    } catch (error) {

      console.error(
        '[Addon Chooser] Hoodie + Cap Ablauf fehlgeschlagen:',
        error
      );


      chooser.showError?.(
        chooser.dataset
          .textAddError ||
        'Die Cap konnte nicht hinzugefügt werden. Bitte versuche es erneut.'
      );


      /*
       * Wichtig: Bei einem Fehler die Unterdrückung sofort lösen. Der
       * Hoodie bleibt im Warenkorb und der Warenkorb wird synchronisiert.
       */
      suppressIntermediateVariantAdded =
        false;

      refreshCart();

    } finally {

      suppressIntermediateVariantAdded =
        false;

      chooser.disableBundleFormProperties?.();

      addonBundleProcessingForms.delete(
        form
      );

    }

  }


  function startBundleIntent({
    chooser,
    form,
    submitter
  }) {

    if (
      !chooser ||
      !form ||
      !submitter
    ) {

      return;

    }


    const mainQuantity =
      getMainQuantity();


    if (
      mainQuantity <= 1
    ) {

      runBundlePurchase({
        chooser,
        form,
        submitter,
        addonQuantity:
          1
      });

      return;

    }


    openAddonQuantityPopup({
      chooser,
      maxQuantity:
        mainQuantity,
      onSelect:
        (addons) => {

          runMultiAddonBundlePurchase({
            chooser,
            form,
            submitter,
            addons
          });

        }
    });

  }


  /*
   * Hauptweg: echter Klick auf "In den Warenkorb".
   */
  document.addEventListener(
    'click',
    (event) => {

      const button =
        event.target.closest?.(
          'button[type="submit"], input[type="submit"]'
        );


      if (
        !button ||
        !isMainProductSubmitButton(
          button
        )
      ) {

        return;

      }


      const form =
        button.form ||
        button.closest?.(
          'form'
        );


      if (
        !form ||
        addonBundleBypassForms.has(
          form
        ) ||
        addonBundleProcessingForms.has(
          form
        )
      ) {

        return;

      }


      const chooser =
        getActiveChooser();


      if (!chooser) {

        return;

      }


      event.preventDefault();
      event.stopImmediatePropagation();


      startBundleIntent({
        chooser,
        form,
        submitter:
          button
      });

    },
    true
  );


  /*
   * Backup für Submit per Enter oder Theme-Sonderfälle.
   * Wenn der normale Button-Klick bereits abgefangen wurde, läuft
   * hier nichts doppelt, weil dieser Submit dann noch nicht entstand.
   */
  document.addEventListener(
    'submit',
    (event) => {

      const productForm =
        findProductForm();


      if (
        !productForm ||
        event.target !== productForm ||
        addonBundleBypassForms.has(
          productForm
        ) ||
        addonBundleProcessingForms.has(
          productForm
        )
      ) {

        return;

      }


      const chooser =
        getActiveChooser();


      if (!chooser) {

        return;

      }


      const submitter =
        event.submitter ||
        productForm.querySelector(
          'button[type="submit"], input[type="submit"]'
        );


      if (!submitter) {

        return;

      }


      event.preventDefault();
      event.stopImmediatePropagation();


      startBundleIntent({
        chooser,
        form:
          productForm,
        submitter
      });

    },
    true
  );


  /* =========================================================
     PROMOS AKTUALISIEREN
     ========================================================= */

  function updateAllPromos() {

    document
      .querySelectorAll(
        'addon-chooser-standalone'
      )
      .forEach(
        (chooser) => {

          chooser
            .updatePromo?.();

        }
      );

  }


  document.addEventListener(
    'change',
    (event) => {

      if (
        event.target.matches(
          '.quantity-selector__input, input[name="quantity"]'
        )
      ) {

        updateAllPromos();

      }

    }
  );


  document.addEventListener(
    'input',
    (event) => {

      if (
        event.target.matches(
          '.quantity-selector__input, input[name="quantity"]'
        )
      ) {

        updateAllPromos();

      }

    }
  );


  document.addEventListener(
    'click',
    (event) => {

      const button =
        event.target.closest(
          '.quantity-selector__button'
        );


      if (
        !button
      ) {

        return;

      }


      setTimeout(
        updateAllPromos,
        0
      );


      setTimeout(
        updateAllPromos,
        100
      );


      setTimeout(
        updateAllPromos,
        250
      );

    }
  );


  /* =========================================================
     RERENDER
     ========================================================= */

  function repositionAllChoosers() {

    const seenSections =
      new Map();


    document
      .querySelectorAll(
        'addon-chooser-standalone'
      )
      .forEach(
        (chooser) => {

          const sectionId =
            chooser.dataset.sectionId;


          if (
            sectionId
          ) {

            if (
              seenSections.has(
                sectionId
              )
            ) {

              const oldChooser =
                seenSections.get(
                  sectionId
                );


              if (
                oldChooser !==
                chooser
              ) {

                oldChooser.remove();

              }

            }


            seenSections.set(
              sectionId,
              chooser
            );

          }

        }
      );


    document
      .querySelectorAll(
        'addon-chooser-standalone'
      )
      .forEach(
        (chooser) => {

          chooser
            .syncInputsToForm?.();


          chooser
            .moveIntoProductInfo?.();


          chooser
            .updatePromo?.();


          chooser
            .updateAddonControlsVisibility?.();


          chooser
            .disableBundleFormProperties?.();


          applySwatchColors(
            chooser
          );


          requestAnimationFrame(
            () => {

              chooser.classList.add(
                'is-addon-ready'
              );

            }
          );

        }
      );

  }


  /* =========================================================
     TEEINBLUE
     ========================================================= */

  document.addEventListener(
    'teeinblue-event-component-injected',
    repositionAllChoosers
  );


  /* =========================================================
     PRODUCT RERENDER
     ========================================================= */

  document.addEventListener(
    'product:rerender',
    () => {

      setTimeout(
        repositionAllChoosers,
        50
      );

    },
    true
  );


  /* =========================================================
     SHOPIFY SECTION LOAD
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    () => {

      setTimeout(
        repositionAllChoosers,
        50
      );

    }
  );


  /* =========================================================
     SHOPIFY BLOCK SELECT
     ========================================================= */

  document.addEventListener(
    'shopify:block:select',
    () => {

      setTimeout(
        repositionAllChoosers,
        50
      );

    }
  );


  /* =========================================================
     START
     ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => {

        repositionAllChoosers();

        updateAllPromos();

        applySwatchColors();

      }
    );

  } else {

    repositionAllChoosers();

    updateAllPromos();

    applySwatchColors();

  }


})();